// import React, { useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   IconButton,
//   Paper,
//   Typography,
// } from "@mui/material";
// import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
// import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
// import { useQuantityContext } from "../QuantityContext";
// import { useDispatch, useSelector } from "react-redux";
// import { postResumePraising, setDeeplinking } from "../../Redux/Reducers/OnboardingReducer";
// import { applyJob } from "../../Redux/Reducers/JobReducer";
// import { getResumeReducer, postResumeReducer } from "../../Redux/Reducers/ProfileReducer";
// import { useUserDetailContext } from "../../Components/UserDetailContext";

// const ActiveStep8 = ({ setActiveStep, onResumeUpload }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch()
//   const fileInputRef = useRef(null);
//   const { openSnackbar, handleInfo } = useQuantityContext();
//   const { userDetails } = useUserDetailContext();
//   const [resumeFile, setResumeFile] = useState(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [isParsing, setIsParsing] = useState(false);
//   const deeLinkURLPath = useSelector((state) => state?.onboarding?.deeplinkURL);
//   const backLinkUrl = deeLinkURLPath?.split('back_link_url=')?.[1];
//   const checkType = deeLinkURLPath.includes('type')
//   const CheckJob = deeLinkURLPath.includes('/job-description/')
//   // console.log("deeLinkURLPath852", deeLinkURLPath)

//   const extractIdFromPath = (path) => {
//     if (!path) return null;
//     const segments = path.split('/');
//     // Get the last segment which is the ID
//     return segments[segments.length - 1];
//   };

//   const jobId = extractIdFromPath(deeLinkURLPath);
//   console.log("JJJJJJJJJJJJJJJ", jobId)

//   const handleBack = () => {
//     if (typeof setActiveStep === "function") {
//       setActiveStep(3);
//       return;
//     }

//     navigate(-1);
//   };

//   const handleSkip = () => {
//     navigate("/home");
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files?.[0];
//     if (!file) return;

//     setResumeFile(file);
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     setIsDragging(false);

//     const file = event.dataTransfer.files?.[0];
//     if (!file) return;

//     setResumeFile(file);
//   };

//   // const handleParseResume = async () => {
//   //   if (!resumeFile) {
//   //     openSnackbar("Upload a resume first, or use Skip to continue.", "info");
//   //     return;
//   //   }

//   //   setIsParsing(true);
//   //   handleInfo("Uploading your resume...");

//   //   try {
//   //     // if (typeof onResumeUpload === "function") {
//   //     //   await onResumeUpload(resumeFile);
//   //     // }
//   //     const res = await dispatch(postResumePraising({ resume: resumeFile }));
//   //     console.log("ResponseResume", res)
//   //     if (res?.type == postResumePraising.fulfilled.type) {
//   //       openSnackbar("Resume parsed successfully!", "success");
//   //       // navigate("/home");
//   //       // window.location.reload()
//   //       if (deeLinkURLPath !== "") {
//   //          let organizationId, id, userType;
//   //          const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
//   //           organizationId = params.get('organizationId');
//   //           // console.log("organizationId", organizationId)
//   //           id = params.get('id');
//   //           userType = params.get('type');
//   //         const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
//   //         window.location.replace(`${baseUrl}/?userType=${userType}`);
//   //         await dispatch(setDeeplinking(""))

//   //       }
//   //     } else {
//   //       console.log('errrror', res);

//   //       openSnackbar("Failed to parse resume", "error");
//   //     }


//   //   } catch (error) {
//   //     console.error("Resume upload failed:", error);
//   //     openSnackbar("Unable to upload the resume right now. Please try again.", "error");
//   //   } finally {
//   //     setIsParsing(false);
//   //   }
//   // };


//   // const handleParseResume = async () => {
//   //   if (!resumeFile) {
//   //     openSnackbar("Upload a resume first, or use Skip to continue.", "info");
//   //     return;
//   //   }

//   //   setIsParsing(true);
//   //   handleInfo("Uploading your resume...");

//   //   try {
//   //     const res = await dispatch(postResumePraising({ resume: resumeFile }));
//   //     // console.log("ResponseResume", res)

//   //     if (res?.type == postResumePraising.fulfilled.type) {
//   //       openSnackbar("Resume parsed successfully!", "success");
//   //       window.location.reload()
//   //       // Check for onboarding paths
//   //       const isOnboarding = backLinkUrl?.includes('/onboarding');
//   //       const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
//   //       const hasOnboardingPath = isOnboarding || isUniversityOnboarding;
//   //       console.log("isOnboarding55555", isOnboarding, isUniversityOnboarding, hasOnboardingPath)
//   //       if (hasOnboardingPath) {
//   //         // Navigate to verify-docs if any onboarding path exists
//   //         navigate("/verify-docs", {
//   //           state: { docType: 'Aadhaar' },
//   //           replace: true
//   //         });
//   //       } else if (checkType) {
//   //         // Original navigation logic for non-onboarding paths
//   //         let organizationId, id, userType;
//   //         const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
//   //         organizationId = params.get('organizationId');
//   //         id = params.get('id');
//   //         userType = params.get('type');
//   //         const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
//   //         window.location.replace(`${baseUrl}/?userType=${userType}`);
//   //         await dispatch(setDeeplinking(""))
//   //       }
//   //       else if (CheckJob) {
//   //         const result = await dispatch(applyJob(jobId))
//   //         if (result?.statusCode === 200 || result?.statusCode === 201) {
//   //           openSnackbar("Successfully applied!", "success");
//   //           console.log("AM Inside CheckJob")
//   //           navigate("/home");
//   //           window.location.reload()

//   //         }
//   //       }
//   //       else {
//   //         navigate("/home");
//   //         window.location.reload()
//   //         // await dispatch(setDeeplinking(""))
//   //       }
//   //     } else {
//   //       console.log('errrror', res);
//   //       openSnackbar("Failed to parse resume", "error");
//   //     }

//   //   } catch (error) {
//   //     console.error("Resume upload failed:", error);
//   //     openSnackbar("Unable to upload the resume right now. Please try again.", "error");
//   //   } finally {
//   //     setIsParsing(false);
//   //   }
//   // };

// //   const handleParseResume = async () => {
// //   if (!resumeFile) {
// //     openSnackbar("Upload a resume first, or use Skip to continue.", "info");
// //     return;
// //   }

// //   setIsParsing(true);
// //   handleInfo("Uploading your resume...");

// //   try {
// //     // First API call - Parse the resume
// //     const res = await dispatch(postResumePraising({ resume: resumeFile }));
// //     console.log("ResponseResume", res)

// //     if (res?.type == postResumePraising.fulfilled.type) {
// //       openSnackbar("Resume parsed successfully!", "success");

// //       // Second API call - Save the resume to database (similar to ResumeGenerate)
// //       try {
// //         // Create a FormData object with the resume file
// //         const formData = new FormData();
// //         formData.append('file', resumeFile);
// //         formData.append('section_slug', 'resume_details');

// //         // Call the postResumeReducer API
// //         const resumeSaveResponse = await dispatch(postResumeReducer(formData));

// //         if (resumeSaveResponse?.payload?.statusCode === 200) {
// //           console.log("Resume saved successfully to database");
// //           // Refresh the resume data
// //           await dispatch(getResumeReducer());
// //         } else {
// //           console.log("Failed to save resume to database");
// //           openSnackbar("Resume parsed but failed to save. Please try again.", "error");
// //         }
// //       } catch (error) {
// //         console.error("Failed to save resume:", error);
// //         openSnackbar("Resume parsed but failed to save. Please try again.", "error");
// //       }

// //       // Check for onboarding paths
// //       const isOnboarding = backLinkUrl?.includes('/onboarding');
// //       const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
// //       const hasOnboardingPath = isOnboarding || isUniversityOnboarding;
// //       console.log("isOnboarding55555", isOnboarding, isUniversityOnboarding, hasOnboardingPath)

// //       if (hasOnboardingPath) {
// //         // Navigate to verify-docs if any onboarding path exists
// //         navigate("/verify-docs", {
// //           state: { docType: 'Aadhaar' },
// //           replace: true
// //         });
// //       } else if (checkType) {
// //         // Original navigation logic for non-onboarding paths
// //         let organizationId, id, userType;
// //         const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
// //         organizationId = params.get('organizationId');
// //         id = params.get('id');
// //         userType = params.get('type');
// //         const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
// //         window.location.replace(`${baseUrl}/?userType=${userType}`);
// //         await dispatch(setDeeplinking(""))
// //       } else if (CheckJob) {
// //         const result = await dispatch(applyJob(jobId))
// //         // console.log("result11111111111", result)
// //         if (result?.payload.statusCode === 200 || result?.payload.statusCode === 201) {
// //           openSnackbar("Successfully applied!", "success");
// //           // console.log("AM Inside CheckJob")
// //           navigate("/home");
// //           window.location.reload()
// //         }
// //       } else {
// //         navigate("/home");
// //         window.location.reload()
// //       }
// //     } else {
// //       console.log('errrror', res);
// //       openSnackbar("Failed to parse resume", "error");
// //     }

// //   } catch (error) {
// //     console.error("Resume upload failed:", error);
// //     openSnackbar("Unable to upload the resume right now. Please try again.", "error");
// //   } finally {
// //     setIsParsing(false);
// //   }
// // };

// // Add this function inside your ActiveStep8 component
// const generateResumePDF = async (
//   ProfessionalData,
//   ProfessonalSkills,
//   ProfessionalExperience,
//   ProfessionalEducation,
//   ProfessionalCertificate,
//   ProfessionalProject,
//   ProfessonalSoftSkills,
//   ProfessonalToolsSkills,
//   userDetails
// ) => {
//   try {
//     // Get the personal data for the resume
//     const Personaldata = useSelector((state) => state?.ProfileArray?.personalProfile?.data);
//     const ProfessionalDataImage = useSelector((state) => state?.ProfileArray?.professionaProfile);

//     // Create the resume HTML (similar to what's in ResumeGenerate)
//     const resumeHTML = createResumeHTML(
//       ProfessionalData,
//       ProfessonalSkills,
//       ProfessionalExperience,
//       ProfessionalEducation,
//       ProfessionalCertificate,
//       ProfessionalProject,
//       ProfessonalSoftSkills,
//       ProfessonalToolsSkills,
//       userDetails,
//       Personaldata,
//       ProfessionalDataImage
//     );

//     // Call the backend to generate PDF
//     const accessToken = localStorage.getItem("objectId");
//     const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/generate-pdf/resume-pdf`, {
//       method: 'POST',
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ 
//         headTags: getHeadTags(userDetails),
//         resumeStyles: getResumeStyles(),
//         htmlContent: resumeHTML 
//       }),
//     });

//     if (!response.ok) {
//       throw new Error(`Failed to generate PDF: ${response.statusText}`);
//     }

//     const pdfBuffer = await response.blob();

//     if (pdfBuffer.size < 1024) {
//       throw new Error('Generated PDF file is too small and may be corrupted.');
//     }

//     // Create a file from the blob
//     const file = new File(
//       [pdfBuffer], 
//       `${userDetails?.firstName || 'User'} Resume-${Date.now()}.pdf`, 
//       { type: 'application/pdf' }
//     );

//     return file;
//   } catch (error) {
//     console.error('Error generating PDF:', error);
//     return null;
//   }
// };

// // Helper function to create the HTML for the resume
// const createResumeHTML = (
//   ProfessionalData,
//   ProfessonalSkills,
//   ProfessionalExperience,
//   ProfessionalEducation,
//   ProfessionalCertificate,
//   ProfessionalProject,
//   ProfessonalSoftSkills,
//   ProfessonalToolsSkills,
//   userDetails,
//   Personaldata,
//   ProfessionalDataImage
// ) => {
//   // Create a temporary div to build the resume HTML
//   const tempDiv = document.createElement('div');
//   tempDiv.className = 'profile-resume';

//   // Build the resume structure similar to ResumeGenerate
//   // This is a simplified version - you might want to copy the exact HTML structure from ResumeGenerate

//   // Side content
//   const sideContent = document.createElement('section');
//   sideContent.className = 'resume-side-content';
//   sideContent.innerHTML = `
//     <div class="resume-header mb-3">
//       <div class="resume-profile-container mb-2">
//         <img src="${ProfessionalDataImage?.user_profile_url || userDetails?.proFile || ''}" alt="${userDetails?.firstName || 'User'}" class="cover-image" />
//       </div>
//       <div class="resume-profile-name">${userDetails?.firstName || ''} ${userDetails?.lastName || ''}</div>
//       <div class="resume-profile-headline">${ProfessionalData?.designation || ''}</div>
//     </div>
//     <div class="resume-divider" />
//     <div class="resume-contact-list">
//       <a href="mailto:${userDetails?.email || ''}" target="_blank" rel="noreferrer">
//         <div class="resume-contact-item">
//           <div class="resume-contact-icon-container"><span>📧</span></div>
//           <div>
//             <div class="resume-contact-label">Email</div>
//             <div class="resume-contact-id">${userDetails?.email || ''}</div>
//           </div>
//         </div>
//       </a>
//       <a href="tel:${userDetails?.phone || ''}" target="_blank" rel="noreferrer">
//         <div class="resume-contact-item">
//           <div class="resume-contact-icon-container"><span>📞</span></div>
//           <div>
//             <div class="resume-contact-label">Phone</div>
//             <div class="resume-contact-id">${userDetails?.phone || ''}</div>
//           </div>
//         </div>
//       </a>
//     </div>
//   `;

//   tempDiv.appendChild(sideContent);

//   // Main body with sections
//   const mainBody = document.createElement('section');
//   mainBody.className = 'resume-main-body';

//   let sectionsHTML = '';

//   // Add Summary section if exists
//   if (ProfessionalData?.about_me) {
//     sectionsHTML += `
//       <section class="resume-main-section">
//         <div class="resume-section-title">Summary</div>
//         <div>
//           <div class="resume-project-desc">${ProfessionalData.about_me}</div>
//         </div>
//       </section>
//     `;
//   }

//   // Add Experience section
//   if (ProfessionalExperience?.length > 0) {
//     const validExperiences = ProfessionalExperience.filter(exp => exp && exp.is_public !== false);
//     if (validExperiences.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-experience-section">
//             <div class="resume-section-title">Experience</div>
//             <div class="resume-section-body">
//               ${validExperiences.map(exp => `
//                 <div class="resume-section-item">
//                   <div class="resume-exp-content-left">
//                     <div class="exp-time-location">
//                       <span>${exp?.start_month || ''} ${exp?.start_year || ''} - ${exp?.is_currently_working ? 'Present' : `${exp?.end_month || ''} ${exp?.end_year || ''}`}</span>
//                     </div>
//                     <div class="exp-name-logo">
//                       ${exp?.company_logo ? `<div class="resume-exp-logo"><img src="${exp.company_logo}" alt="logo" class="contain-image" /></div>` : ''}
//                       <div class="resume-exp-name">
//                         <div class="resume-exp-designation">${exp?.role_title || ''}</div>
//                         <div class="resume-exp-company">${exp?.company_name || ''}</div>
//                       </div>
//                     </div>
//                   </div>
//                   ${exp?.details ? `<div class="resume-project-desc line-break ps-3 py-2">${exp.details}</div>` : ''}
//                 </div>
//               `).join('')}
//             </div>
//           </div>
//         </section>
//       `;
//     }
//   }

//   // Add Education section
//   if (ProfessionalEducation?.length > 0) {
//     const validEducation = ProfessionalEducation.filter(edu => edu && edu.is_public !== false);
//     if (validEducation.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-education-section">
//             <div class="resume-section-title">Education</div>
//             <div class="resume-section-body">
//               ${validEducation.map(edu => `
//                 <div class="resume-section-item">
//                   <div class="edu-name-logo">
//                     ${edu?.logo_link ? `<img src="${edu.logo_link}" alt="Institute Logo" />` : ''}
//                     <div>${edu?.institute_name || ''}</div>
//                   </div>
//                   <div class="edu-degree-time">
//                     <div class="resume-edu-degree">${edu?.degree || edu?.educational_level || ''}</div>
//                     <div class="resume-edu-time">${edu?.start_year || ''} - ${edu?.is_pursuing ? 'Present' : edu?.end_year || ''}</div>
//                   </div>
//                 </div>
//               `).join('')}
//             </div>
//           </div>
//         </section>
//       `;
//     }
//   }

//   // Add Skills sections
//   if (ProfessonalSoftSkills?.length > 0) {
//     sectionsHTML += `
//       <section class="resume-main-section">
//         <div class="resume-skills-section">
//           <div class="resume-section-title">Soft Skills</div>
//           <div class="resume-section-body">
//             <div class="d-flex flex-column gap-2">
//               <div class="resume-skills-row">
//                 ${ProfessonalSoftSkills.map(skill => `
//                   <div class="resume-section-item word-break">${skill}</div>
//                 `).join('')}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     `;
//   }

//   if (ProfessonalSkills?.length > 0) {
//     sectionsHTML += `
//       <section class="resume-main-section">
//         <div class="resume-skills-section">
//           <div class="resume-section-title">Professional Skills</div>
//           <div class="resume-section-body">
//             <div class="d-flex flex-column gap-2">
//               <div class="resume-skills-row">
//                 ${ProfessonalSkills.map(skill => `
//                   <div class="resume-section-item word-break">${skill}</div>
//                 `).join('')}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     `;
//   }

//   if (ProfessonalToolsSkills?.length > 0) {
//     sectionsHTML += `
//       <section class="resume-main-section">
//         <div class="resume-tools-section">
//           <div class="resume-section-title">Tools</div>
//           <div class="resume-section-body">
//             <div class="resume-skills-row resume-tools-row">
//               ${ProfessonalToolsSkills.map(tool => `
//                 <div class="resume-section-item word-break">${tool}</div>
//               `).join('')}
//             </div>
//           </div>
//         </div>
//       </section>
//     `;
//   }

//   mainBody.innerHTML = sectionsHTML;
//   tempDiv.appendChild(mainBody);

//   return tempDiv.outerHTML;
// };

// // Helper functions for head tags and styles
// const getHeadTags = (userDetails) => {
//   return `
//     <meta name="viewport" content="width=device-width, initial-scale=1" />
//     <title>${userDetails?.firstName || 'User'}'s Resume</title>
//   `;
// };

// const getResumeStyles = () => {
//   return `
//     .profile-resume {color: rgb(0, 0, 0, 0.87); font-family: 'Lato', sans-serif; font-size: 11pt; display: flex; flex-direction: row; }
//     .profile-resume .resume-side-content { flex: 0 0 30%; background-color: #F7F9FC; padding: 20px; height: 100vh; min-height: 100vh; }
//     .profile-resume .resume-main-body { flex: 0 0 70%; background-color: #ffffff; padding: 24px 16px 24px 16px; position: relative; }
//     .resume-main-section { padding-bottom: 20px; padding-left: 20px; }
//     .resume-main-body-wrapper .drag-item:not(:last-child) .resume-main-section { border-left: 1px solid #E2E6EE; }
//     .resume-side-content .resume-header .resume-profile-container { height: 4rem; width: 4rem; border-radius: 50%; overflow: hidden; }
//     .resume-profile-name { font-size: 12pt; font-weight: 700; }
//     .resume-profile-headline { font-weight: 700; color: rgba(0, 0, 0, 0.60); }
//     .resume-side-content .resume-divider { background-color: #EDF0F5; height: 1px; width: 100%; margin: 1rem 0; }
//     .resume-side-content .resume-contact-list { display: flex; flex-direction: column; gap: 0.5rem; }
//     .resume-contact-list a { text-decoration: none; color: unset; }
//     .resume-contact-item { display: flex; align-items: center; gap: 0.5rem; }
//     .resume-contact-icon-container { border-radius: 50%; height: 24px; width: 24px; background-color: #E2E6EE; display: flex; justify-content: center; align-items: center; }
//     .resume-contact-id { font-size: 11pt; color: rgb(0, 0, 0, 0.87); }
//     .resume-section-title::before { content: '•'; height: 1.5rem; width: 1.5rem; background-color: white; position: absolute; left: -30px; top: -4px;
//       border-radius: 50%; display: flex; align-items: center; justify-content: center;
//       color: purple; font-size: 14pt; }
//     .resume-main-section .resume-section-title { font-size: 12.5pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 1rem; position: relative; }
//     .resume-project-section .resume-section-body { display: grid; grid-template-columns: repeat(2, 1fr); gap: 4px; }
//     .resume-project-section .resume-section-item { display: flex; flex-direction: column; gap: 8px; padding: 10px; background-color: #F7F9FC; border-radius: 4px; overflow: hidden; }
//     .resume-project-title { font-size: 11pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 4px; }
//     .resume-project-desc { font-size: 10pt; color: rgba(0, 0, 0, 0.60); line-break: pre-line; }
//     .resume-experience-section .resume-section-body { padding-left: 20px; display: flex; flex-direction: column; }
//     .resume-experience-section .resume-section-item { display: flex; justify-content: flex-start; gap: 6px; padding: 4px 0 8px; overflow: hidden; color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
//     .resume-experience-section .resume-section-item:not(:last-child) { border-bottom: 0.7px solid lightgray; }
//     .resume-exp-content-left .exp-time-location { margin-bottom: 0.25rem; padding-left: 12px; position: relative; }
//     .resume-exp-content-left .exp-time-location::before { content: ''; height: 4px; width: 4px; background-color: black; position: absolute; left: 0; top: 4px; border-radius: 50%; }
//     .resume-exp-content-left .exp-name-logo { display: flex; gap: 8px; align-items: center; padding-left: 12px; border-left: 1px solid #F7F9FC; margin-left: 1px; }
//     .exp-name-logo .resume-exp-logo { height: 34px; width: 34px; overflow: hidden; }
//     .resume-exp-logo img { height: 100%; width: 100%; object-fit: contain; }
//     .resume-exp-name .resume-exp-designation { color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
//     .resume-exp-name .resume-exp-company { color: rgb(0, 0, 0, 0.87); font-size: 11pt; }
//     .resume-education-section .resume-section-body { display: flex; flex-wrap: wrap; gap: 4px; }
//     .resume-education-section .resume-section-item { flex: 0 0 30%; border-radius: 4px; padding: 6px 12px; background-color: #F7F9FC; display: flex; flex-direction: column; gap: 4px; font-size: 10pt; max-width: 32%; }
//     .resume-section-item .edu-name-logo { display: flex; align-items: center; gap: 4px; }
//     .resume-section-item .edu-name-logo img { height: 28px; width: 28px; object-fit: contain; overflow: hidden; }
//     .resume-section-item .edu-degree-time .resume-edu-degree { font-size: 10pt; font-weight: 700; margin-bottom: 1px; }
//     .resume-section-item .edu-degree-time .resume-edu-time { color: rgba(0, 0, 0, 0.60); }
//     .resume-skills-section .resume-section-body { display: flex; flex-direction: column; gap: 8px; }
//     .resume-skills-row { display: flex; gap: 8px; flex-wrap: wrap; flex: 0 0 68%; }
//     .resume-skills-row .resume-section-item { border-radius: 4px; padding: 6px 4px; background-color: #F7F9FC; max-width: 70%; overflow: hidden; display: flex; align-items: center; }
//     .resume-tools-section .resume-section-body { display: flex; }
//     .resume-section-body .resume-skills-row.resume-tools-row { flex: 0 0 90%; max-width: 90%; }
//     .contain-image { height: 100%; width: 100%; object-fit: contain; }
//     .cover-image { height: 100%; width: 100%; object-fit: cover; }
//     .d-flex { display: flex !important; }
//     .flex-column { flex-direction: column !important; }
//     .gap-2 { gap: 0.5rem; }
//     .word-break { word-break: break-word; }
//     .line-break { white-space: pre-line; }
//     .ps-3 {padding-left: 1rem}
//     .py-2 {padding-top: .5rem !important;padding-bottom: .5rem !important;}
//     @page { size: A4; margin: 2mm 2mm 2mm 2mm; }
//     * { box-sizing: border-box; }
//   `;
// };

// const handleParseResume = async () => {
//   if (!resumeFile) {
//     openSnackbar("Upload a resume first, or use Skip to continue.", "info");
//     return;
//   }

//   setIsParsing(true);
//   handleInfo("Uploading your resume...");

//   try {
//     // First API call - Parse the resume
//     const res = await dispatch(postResumePraising({ resume: resumeFile }));
//     console.log("ResponseResume", res)

//     if (res?.type == postResumePraising.fulfilled.type) {
//       openSnackbar("Resume parsed successfully!", "success");

//       // Wait a bit for profile data to update
//       await new Promise(resolve => setTimeout(resolve, 1500));

//       // Now generate the AI resume after profile is updated
//       try {
//         handleInfo("Generating your AI resume...");

//         // Get the updated profile data from Redux
//         const ProfessionalData = useSelector((state) => state?.ProfileArray?.professionaProfile?.about_me);
//         const ProfessonalSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_skills?.skills);
//         const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data);
//         const ProfessionalEducation = useSelector((state) => state?.ProfileArray?.educationData?.data);
//         const ProfessionalCertificate = useSelector((state) => state?.ProfileArray?.certificateData?.data);
//         const ProfessionalProject = useSelector((state) => state?.ProfileArray?.projectData?.data);
//         const ProfessonalSoftSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.soft_skills?.skills);
//         const ProfessonalToolsSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_tools?.skills);

//         // Get user details
//         const userFirstName = userDetails?.firstName;
//         const userLastName = userDetails?.lastName;

//         // Generate the PDF using the same logic as ResumeGenerate component
//         const pdfFile = await generateResumePDF(
//           ProfessionalData,
//           ProfessonalSkills,
//           ProfessionalExperience,
//           ProfessionalEducation,
//           ProfessionalCertificate,
//           ProfessionalProject,
//           ProfessonalSoftSkills,
//           ProfessonalToolsSkills,
//           userDetails
//         );

//         if (pdfFile) {
//           // Save the generated resume to database
//           const formData = new FormData();
//           formData.append('file', pdfFile);
//           formData.append('section_slug', 'resume_details');

//           const saveResponse = await dispatch(postResumeReducer(formData));

//           if (saveResponse?.payload?.statusCode === 200) {
//             await dispatch(getResumeReducer());
//             handleInfo("AI Resume generated successfully!");
//             openSnackbar("AI Resume generated and saved!", "success");
//           } else {
//             openSnackbar("Failed to save generated resume", "error");
//           }
//         }
//       } catch (error) {
//         console.error("Failed to generate AI resume:", error);
//         openSnackbar("Resume parsed but AI generation failed", "error");
//       }

//       // Your existing navigation logic...
//       const isOnboarding = backLinkUrl?.includes('/onboarding');
//       const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
//       const hasOnboardingPath = isOnboarding || isUniversityOnboarding;

//       if (hasOnboardingPath) {
//         navigate("/verify-docs", {
//           state: { docType: 'Aadhaar' },
//           replace: true
//         });
//       } else if (checkType) {
//         let organizationId, id, userType;
//         const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
//         organizationId = params.get('organizationId');
//         id = params.get('id');
//         userType = params.get('type');
//         const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
//         window.location.replace(`${baseUrl}/?userType=${userType}`);
//         await dispatch(setDeeplinking(""))
//       } else if (CheckJob) {
//         const result = await dispatch(applyJob(jobId))
//         if (result?.statusCode === 200 || result?.statusCode === 201) {
//           openSnackbar("Successfully applied!", "success");
//           navigate("/home");
//           window.location.reload()
//         }
//       } else {
//         navigate("/home");
//         window.location.reload()
//       }
//     } else {
//       console.log('errrror', res);
//       openSnackbar("Failed to parse resume", "error");
//     }

//   } catch (error) {
//     console.error("Resume upload failed:", error);
//     openSnackbar("Unable to upload the resume right now. Please try again.", "error");
//   } finally {
//     setIsParsing(false);
//   }
// };

//   const selectedFileLabel = resumeFile
//     ? `${resumeFile.name} - ${(resumeFile.size / (1024 * 1024)).toFixed(1)} MB`
//     : "PDF, DOC, or DOCX up to 10MB";

//   return (
//     <Box
//       sx={{
//         minHeight: "calc(100vh - 180px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         px: { xs: 2, sm: 3 },
//         py: { xs: 2, md: 4 },
//         backgroundColor: "#ffffff",
//       }}
//     >
//       <Paper
//         elevation={0}
//         sx={{
//           width: "100%",
//           maxWidth: 720,
//           borderRadius: 5,
//           overflow: "hidden",
//           backgroundColor: "#ffffff",
//           color: "#111827",
//           border: "1px solid rgba(0, 68, 198, 0.12)",
//           boxShadow: "0 20px 55px rgba(0, 68, 198, 0.12)",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             px: { xs: 2, sm: 3 },
//             pt: { xs: 2, sm: 2.5 },
//           }}
//         >
//           <IconButton
//             onClick={handleBack}
//             aria-label="Go back"
//             sx={{
//               color: "#0044C6",
//               bgcolor: "rgba(0, 68, 198, 0.06)",
//               "&:hover": { bgcolor: "rgba(0, 68, 198, 0.12)" },
//             }}
//           >
//             <ArrowBackRoundedIcon />
//           </IconButton>

//           <Button
//             onClick={handleSkip}
//             sx={{
//               color: "#0044C6",
//               fontWeight: 700,
//               fontSize: "0.98rem",
//               textTransform: "none",
//               minWidth: 0,
//               p: 0,
//               "&:hover": {
//                 backgroundColor: "transparent",
//                 opacity: 0.9,
//               },
//             }}
//           >
//             Skip
//           </Button>
//         </Box>

//         <Box
//           sx={{
//             px: { xs: 2, sm: 4, md: 6 },
//             pt: { xs: 2, sm: 3 },
//             pb: { xs: 2, sm: 4 },
//             textAlign: "center",
//           }}
//         >
//           <Box
//             sx={{
//               width: 92,
//               height: 92,
//               borderRadius: "50%",
//               display: "grid",
//               placeItems: "center",
//               mx: "auto",
//               mb: 2.5,
//               background: "rgba(0, 68, 198, 0.08)",
//               boxShadow: "inset 0 0 0 1px rgba(0, 68, 198, 0.12)",
//             }}
//           >
//             <CloudUploadOutlinedIcon sx={{ fontSize: 42, color: "#0044C6" }} />
//           </Box>

//           <Typography
//             variant="h4"
//             sx={{
//               fontSize: { xs: "1.55rem", sm: "2rem" },
//               fontWeight: 800,
//               lineHeight: 1.15,
//               mb: 1.5,
//               color: "#0f172a",
//             }}
//           >
//             Autofill Your Profile
//           </Typography>

//           <Typography
//             sx={{
//               color: "#475569",
//               maxWidth: 560,
//               mx: "auto",
//               fontSize: { xs: "0.98rem", sm: "1.05rem" },
//               lineHeight: 1.65,
//             }}
//           >
//             Upload your resume to automatically fill your profile, experience,
//             education, and skills in seconds.
//           </Typography>

//           <Box
//             onClick={() => fileInputRef.current?.click()}
//             onDragOver={(event) => {
//               event.preventDefault();
//               setIsDragging(true);
//             }}
//             onDragLeave={() => setIsDragging(false)}
//             onDrop={handleDrop}
//             sx={{
//               mt: { xs: 3, sm: 4 },
//               border: "1.8px dashed rgba(0, 68, 198, 0.35)",
//               borderRadius: 3,
//               minHeight: { xs: 170, sm: 190 },
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               px: 3,
//               py: 3,
//               cursor: "pointer",
//               backgroundColor: isDragging ? "rgba(0, 68, 198, 0.05)" : "#f8fbff",
//               transition: "all 180ms ease",
//               "&:hover": {
//                 borderColor: "#0044C6",
//                 backgroundColor: "#f1f7ff",
//               },
//             }}
//           >
//             <Box
//               sx={{
//                 width: 58,
//                 height: 58,
//                 borderRadius: "50%",
//                 display: "grid",
//                 placeItems: "center",
//                 mb: 1.5,
//                 backgroundColor: "rgba(0, 68, 198, 0.06)",
//               }}
//             >
//               <DescriptionOutlinedIcon sx={{ color: "#0044C6", fontSize: 30 }} />
//             </Box>

//             <Typography
//               sx={{
//                 color: "#0044C6",
//                 fontWeight: 800,
//                 fontSize: "1.05rem",
//                 lineHeight: 1.2,
//               }}
//             >
//               {resumeFile ? "Resume selected" : "Upload Resume"}
//             </Typography>

//             <Typography
//               sx={{
//                 color: "#64748b",
//                 fontSize: "0.92rem",
//                 mt: 0.5,
//                 textAlign: "center",
//               }}
//             >
//               {selectedFileLabel}
//             </Typography>

//             {resumeFile && (
//               <Box
//                 sx={{
//                   mt: 1.5,
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 0.8,
//                   color: "#0044C6",
//                   fontSize: "0.9rem",
//                   fontWeight: 600,
//                 }}
//               >
//                 <CheckCircleRoundedIcon sx={{ fontSize: 18 }} />
//                 Ready to upload
//               </Box>
//             )}

//             <input
//               ref={fileInputRef}
//               type="file"
//               hidden
//               accept=".pdf,.doc,.docx,.rtf"
//               onChange={handleFileChange}
//             />
//           </Box>

//           <Box
//             sx={{
//               mt: 2,
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <Typography
//               sx={{
//                 color: "#64748b",
//                 fontSize: "0.9rem",
//               }}
//             >
//               10MB max file size
//             </Typography>
//           </Box>

//           <Box
//             sx={{
//               mt: { xs: 4, sm: 5 },
//               display: "grid",
//               gap: 1.25,
//             }}
//           >
//             <Button
//               variant="contained"
//               onClick={handleParseResume}
//               disabled={isParsing}
//               sx={{
//                 py: 1.35,
//                 borderRadius: 2,
//                 background: "#0044C6",
//                 color: "#ffffff",
//                 fontWeight: 800,
//                 textTransform: "none",
//                 fontSize: "1rem",
//                 boxShadow: "none",
//                 "&:hover": {
//                   background: "#003aa9",
//                   boxShadow: "none",
//                 },
//                 "&.Mui-disabled": {
//                   color: "#ffffff",
//                   opacity: 0.72,
//                 },
//               }}
//             >
//               {isParsing ? "Uploading Resume..." : "Parse Resume"}
//             </Button>

//             <Button
//               variant="text"
//               onClick={handleSkip}
//               sx={{
//                 color: "#0044C6",
//                 textTransform: "none",
//                 fontWeight: 700,
//                 opacity: 0.82,
//                 "&:hover": {
//                   backgroundColor: "transparent",
//                   opacity: 1,
//                 },
//               }}
//             >
//               Skip for now
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default ActiveStep8;




// import React, { useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   IconButton,
//   Paper,
//   Typography,
// } from "@mui/material";
// import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
// import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
// import { useQuantityContext } from "../QuantityContext";
// import { useDispatch, useSelector } from "react-redux";
// import { postResumePraising, setDeeplinking } from "../../Redux/Reducers/OnboardingReducer";
// import { applyJob } from "../../Redux/Reducers/JobReducer";
// import { getResumeReducer, postResumeReducer } from "../../Redux/Reducers/ProfileReducer";
// import { useUserDetailContext } from "../../Components/UserDetailContext";

// const ActiveStep8 = ({ setActiveStep, onResumeUpload }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const fileInputRef = useRef(null);
//   const { openSnackbar, handleInfo } = useQuantityContext();
//   const { userDetails } = useUserDetailContext();
//   const [resumeFile, setResumeFile] = useState(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [isParsing, setIsParsing] = useState(false);

//   // Get all required data from Redux at the component level
//   const deeLinkURLPath = useSelector((state) => state?.onboarding?.deeplinkURL);
//   const ProfessionalData = useSelector((state) => state?.ProfileArray?.professionaProfile);
//   const ProfessonalSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_skills?.skills);
//   const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data);
//   const ProfessionalEducation = useSelector((state) => state?.ProfileArray?.educationData?.data);
//   const ProfessionalCertificate = useSelector((state) => state?.ProfileArray?.certificateData?.data);
//   const ProfessionalProject = useSelector((state) => state?.ProfileArray?.projectData?.data);
//   const ProfessonalSoftSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.soft_skills?.skills);
//   const ProfessonalToolsSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_tools?.skills);
//   const Personaldata = useSelector((state) => state?.ProfileArray?.personalProfile?.data);
//   const ProfessionalDataImage = useSelector((state) => state?.ProfileArray?.professionaProfile);
// console.log("ProfessionalProjectMMMMMMMMM", ProfessionalProject)
//   const backLinkUrl = deeLinkURLPath?.split('back_link_url=')?.[1];
//   const checkType = deeLinkURLPath?.includes('type');
//   const CheckJob = deeLinkURLPath?.includes('/job-description/');

//   const extractIdFromPath = (path) => {
//     if (!path) return null;
//     const segments = path.split('/');
//     return segments[segments.length - 1];
//   };

//   const jobId = extractIdFromPath(deeLinkURLPath);

//   const handleBack = () => {
//     if (typeof setActiveStep === "function") {
//       setActiveStep(3);
//       return;
//     }
//     navigate(-1);
//   };

//   const handleSkip = () => {
//     navigate("/home");
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files?.[0];
//     if (!file) return;
//     setResumeFile(file);
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     setIsDragging(false);
//     const file = event.dataTransfer.files?.[0];
//     if (!file) return;
//     setResumeFile(file);
//   };

//   // Helper function to create the HTML for the resume
//   const createResumeHTML = (
//     profData,
//     profSkills,
//     profExperience,
//     profEducation,
//     profCertificate,
//     profProject,
//     softSkills,
//     toolsSkills,
//     userDetail,
//     personalData,
//     profImageData
//   ) => {
//     const tempDiv = document.createElement('div');
//     tempDiv.className = 'profile-resume';

//     // Side content
//     const sideContent = document.createElement('section');
//     sideContent.className = 'resume-side-content';
//     sideContent.innerHTML = `
//       <div class="resume-header mb-3">
//         <div class="resume-profile-container mb-2">
//           <img src="${profImageData?.user_profile_url || userDetail?.proFile || ''}" alt="${userDetail?.firstName || 'User'}" class="cover-image" />
//         </div>
//         <div class="resume-profile-name">${userDetail?.firstName || ''} ${userDetail?.lastName || ''}</div>
//         <div class="resume-profile-headline">${profData?.designation || ''}</div>
//       </div>
//       <div class="resume-divider" />
//       <div class="resume-contact-list">
//         <a href="mailto:${userDetail?.email || ''}" target="_blank" rel="noreferrer">
//           <div class="resume-contact-item">
//             <div class="resume-contact-icon-container"><span>📧</span></div>
//             <div>
//               <div class="resume-contact-label">Email</div>
//               <div class="resume-contact-id">${userDetail?.email || ''}</div>
//             </div>
//           </div>
//         </a>
//         <a href="tel:${userDetail?.phone || ''}" target="_blank" rel="noreferrer">
//           <div class="resume-contact-item">
//             <div class="resume-contact-icon-container"><span>📞</span></div>
//             <div>
//               <div class="resume-contact-label">Phone</div>
//               <div class="resume-contact-id">${userDetail?.phone || ''}</div>
//             </div>
//           </div>
//         </a>
//       </div>
//     `;
//     tempDiv.appendChild(sideContent);

//     // Main body with sections
//     const mainBody = document.createElement('section');
//     mainBody.className = 'resume-main-body';
//     let sectionsHTML = '';

//     // Add Summary section if exists
//     if (profData?.about_me) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-section-title">Summary</div>
//           <div>
//             <div class="resume-project-desc">${profData.about_me}</div>
//           </div>
//         </section>
//       `;
//     }

//     // Add Experience section
//     if (profExperience?.length > 0) {
//       const validExperiences = profExperience.filter(exp => exp && exp.is_public !== false);
//       if (validExperiences.length > 0) {
//         sectionsHTML += `
//           <section class="resume-main-section">
//             <div class="resume-experience-section">
//               <div class="resume-section-title">Experience</div>
//               <div class="resume-section-body">
//                 ${validExperiences.map(exp => `
//                   <div class="resume-section-item">
//                     <div class="resume-exp-content-left">
//                       <div class="exp-time-location">
//                         <span>${exp?.start_month || ''} ${exp?.start_year || ''} - ${exp?.is_currently_working ? 'Present' : `${exp?.end_month || ''} ${exp?.end_year || ''}`}</span>
//                       </div>
//                       <div class="exp-name-logo">
//                         ${exp?.company_logo ? `<div class="resume-exp-logo"><img src="${exp.company_logo}" alt="logo" class="contain-image" /></div>` : ''}
//                         <div class="resume-exp-name">
//                           <div class="resume-exp-designation">${exp?.role_title || ''}</div>
//                           <div class="resume-exp-company">${exp?.company_name || ''}</div>
//                         </div>
//                       </div>
//                     </div>
//                     ${exp?.details ? `<div class="resume-project-desc line-break ps-3 py-2">${exp.details}</div>` : ''}
//                   </div>
//                 `).join('')}
//               </div>
//             </div>
//           </section>
//         `;
//       }
//     }

//     // Add Education section
//     if (profEducation?.length > 0) {
//       const validEducation = profEducation.filter(edu => edu && edu);
//       if (validEducation.length > 0) {
//         sectionsHTML += `
//           <section class="resume-main-section">
//             <div class="resume-education-section">
//               <div class="resume-section-title">Education</div>
//               <div class="resume-section-body">
//                 ${validEducation.map(edu => `
//                   <div class="resume-section-item">
//                     <div class="edu-name-logo">
//                       ${edu?.logo_link ? `<img src="${edu.logo_link}" alt="Institute Logo" />` : ''}
//                       <div>${edu?.institute_name || ''}</div>
//                     </div>
//                     <div class="edu-degree-time">
//                       <div class="resume-edu-degree">${edu?.degree || edu?.educational_level || ''}</div>
//                       <div class="resume-edu-time">${edu?.start_year || ''} - ${edu?.is_pursuing ? 'Present' : edu?.end_year || ''}</div>
//                     </div>
//                   </div>
//                 `).join('')}
//               </div>
//             </div>
//           </section>
//         `;
//       }
//     }

//     // Add Skills sections
//     if (softSkills?.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-skills-section">
//             <div class="resume-section-title">Soft Skills</div>
//             <div class="resume-section-body">
//               <div class="d-flex flex-column gap-2">
//                 <div class="resume-skills-row">
//                   ${softSkills.map(skill => `
//                     <div class="resume-section-item word-break">${skill}</div>
//                   `).join('')}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     if (profSkills?.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-skills-section">
//             <div class="resume-section-title">Professional Skills</div>
//             <div class="resume-section-body">
//               <div class="d-flex flex-column gap-2">
//                 <div class="resume-skills-row">
//                   ${profSkills.map(skill => `
//                     <div class="resume-section-item word-break">${skill}</div>
//                   `).join('')}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     if (toolsSkills?.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-tools-section">
//             <div class="resume-section-title">Tools</div>
//             <div class="resume-section-body">
//               <div class="resume-skills-row resume-tools-row">
//                 ${toolsSkills.map(tool => `
//                   <div class="resume-section-item word-break">${tool}</div>
//                 `).join('')}
//               </div>
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     mainBody.innerHTML = sectionsHTML;
//     tempDiv.appendChild(mainBody);

//     return tempDiv.outerHTML;
//   };

//   // Helper functions for head tags and styles
//   const getHeadTags = (userDetail) => {
//     return `
//       <meta name="viewport" content="width=device-width, initial-scale=1" />
//       <title>${userDetail?.firstName || 'User'}'s Resume</title>
//     `;
//   };

//   const getResumeStyles = () => {
//     return `
//       .profile-resume {color: rgb(0, 0, 0, 0.87); font-family: 'Lato', sans-serif; font-size: 11pt; display: flex; flex-direction: row; }
//       .profile-resume .resume-side-content { flex: 0 0 30%; background-color: #F7F9FC; padding: 20px; height: 100vh; min-height: 100vh; }
//       .profile-resume .resume-main-body { flex: 0 0 70%; background-color: #ffffff; padding: 24px 16px 24px 16px; position: relative; }
//       .resume-main-section { padding-bottom: 20px; padding-left: 20px; }
//       .resume-main-body-wrapper .drag-item:not(:last-child) .resume-main-section { border-left: 1px solid #E2E6EE; }
//       .resume-side-content .resume-header .resume-profile-container { height: 4rem; width: 4rem; border-radius: 50%; overflow: hidden; }
//       .resume-profile-name { font-size: 12pt; font-weight: 700; }
//       .resume-profile-headline { font-weight: 700; color: rgba(0, 0, 0, 0.60); }
//       .resume-side-content .resume-divider { background-color: #EDF0F5; height: 1px; width: 100%; margin: 1rem 0; }
//       .resume-side-content .resume-contact-list { display: flex; flex-direction: column; gap: 0.5rem; }
//       .resume-contact-list a { text-decoration: none; color: unset; }
//       .resume-contact-item { display: flex; align-items: center; gap: 0.5rem; }
//       .resume-contact-icon-container { border-radius: 50%; height: 24px; width: 24px; background-color: #E2E6EE; display: flex; justify-content: center; align-items: center; }
//       .resume-contact-id { font-size: 11pt; color: rgb(0, 0, 0, 0.87); }
//       .resume-section-title::before { content: '•'; height: 1.5rem; width: 1.5rem; background-color: white; position: absolute; left: -30px; top: -4px;
//         border-radius: 50%; display: flex; align-items: center; justify-content: center;
//         color: purple; font-size: 14pt; }
//       .resume-main-section .resume-section-title { font-size: 12.5pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 1rem; position: relative; }
//       .resume-project-section .resume-section-body { display: grid; grid-template-columns: repeat(2, 1fr); gap: 4px; }
//       .resume-project-section .resume-section-item { display: flex; flex-direction: column; gap: 8px; padding: 10px; background-color: #F7F9FC; border-radius: 4px; overflow: hidden; }
//       .resume-project-title { font-size: 11pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 4px; }
//       .resume-project-desc { font-size: 10pt; color: rgba(0, 0, 0, 0.60); line-break: pre-line; }
//       .resume-experience-section .resume-section-body { padding-left: 20px; display: flex; flex-direction: column; }
//       .resume-experience-section .resume-section-item { display: flex; justify-content: flex-start; gap: 6px; padding: 4px 0 8px; overflow: hidden; color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
//       .resume-experience-section .resume-section-item:not(:last-child) { border-bottom: 0.7px solid lightgray; }
//       .resume-exp-content-left .exp-time-location { margin-bottom: 0.25rem; padding-left: 12px; position: relative; }
//       .resume-exp-content-left .exp-time-location::before { content: ''; height: 4px; width: 4px; background-color: black; position: absolute; left: 0; top: 4px; border-radius: 50%; }
//       .resume-exp-content-left .exp-name-logo { display: flex; gap: 8px; align-items: center; padding-left: 12px; border-left: 1px solid #F7F9FC; margin-left: 1px; }
//       .exp-name-logo .resume-exp-logo { height: 34px; width: 34px; overflow: hidden; }
//       .resume-exp-logo img { height: 100%; width: 100%; object-fit: contain; }
//       .resume-exp-name .resume-exp-designation { color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
//       .resume-exp-name .resume-exp-company { color: rgb(0, 0, 0, 0.87); font-size: 11pt; }
//       .resume-education-section .resume-section-body { display: flex; flex-wrap: wrap; gap: 4px; }
//       .resume-education-section .resume-section-item { flex: 0 0 30%; border-radius: 4px; padding: 6px 12px; background-color: #F7F9FC; display: flex; flex-direction: column; gap: 4px; font-size: 10pt; max-width: 32%; }
//       .resume-section-item .edu-name-logo { display: flex; align-items: center; gap: 4px; }
//       .resume-section-item .edu-name-logo img { height: 28px; width: 28px; object-fit: contain; overflow: hidden; }
//       .resume-section-item .edu-degree-time .resume-edu-degree { font-size: 10pt; font-weight: 700; margin-bottom: 1px; }
//       .resume-section-item .edu-degree-time .resume-edu-time { color: rgba(0, 0, 0, 0.60); }
//       .resume-skills-section .resume-section-body { display: flex; flex-direction: column; gap: 8px; }
//       .resume-skills-row { display: flex; gap: 8px; flex-wrap: wrap; flex: 0 0 68%; }
//       .resume-skills-row .resume-section-item { border-radius: 4px; padding: 6px 4px; background-color: #F7F9FC; max-width: 70%; overflow: hidden; display: flex; align-items: center; }
//       .resume-tools-section .resume-section-body { display: flex; }
//       .resume-section-body .resume-skills-row.resume-tools-row { flex: 0 0 90%; max-width: 90%; }
//       .contain-image { height: 100%; width: 100%; object-fit: contain; }
//       .cover-image { height: 100%; width: 100%; object-fit: cover; }
//       .d-flex { display: flex !important; }
//       .flex-column { flex-direction: column !important; }
//       .gap-2 { gap: 0.5rem; }
//       .word-break { word-break: break-word; }
//       .line-break { white-space: pre-line; }
//       .ps-3 {padding-left: 1rem}
//       .py-2 {padding-top: .5rem !important;padding-bottom: .5rem !important;}
//       @page { size: A4; margin: 2mm 2mm 2mm 2mm; }
//       * { box-sizing: border-box; }
//     `;
//   };

//   // Function to generate PDF
//   const generateResumePDF = async () => {
//     try {
//       // Create the resume HTML using the data from Redux
//       const resumeHTML = createResumeHTML(
//         ProfessionalData,
//         ProfessonalSkills,
//         ProfessionalExperience,
//         ProfessionalEducation,
//         ProfessionalCertificate,
//         ProfessionalProject,
//         ProfessonalSoftSkills,
//         ProfessonalToolsSkills,
//         userDetails,
//         Personaldata,
//         ProfessionalDataImage
//       );

//       // Call the backend to generate PDF
//       const accessToken = localStorage.getItem("objectId");
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/generate-pdf/resume-pdf`, {
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 
//           headTags: getHeadTags(userDetails),
//           resumeStyles: getResumeStyles(),
//           htmlContent: resumeHTML 
//         }),
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to generate PDF: ${response.statusText}`);
//       }

//       const pdfBuffer = await response.blob();

//       if (pdfBuffer.size < 1024) {
//         throw new Error('Generated PDF file is too small and may be corrupted.');
//       }

//       // Create a file from the blob
//       const file = new File(
//         [pdfBuffer], 
//         `${userDetails?.firstName || 'User'} Resume-${Date.now()}.pdf`, 
//         { type: 'application/pdf' }
//       );

//       return file;
//     } catch (error) {
//       console.error('Error generating PDF:', error);
//       return null;
//     }
//   };

//   const handleParseResume = async () => {
//     if (!resumeFile) {
//       openSnackbar("Upload a resume first, or use Skip to continue.", "info");
//       return;
//     }

//     setIsParsing(true);
//     handleInfo("Uploading your resume...");

//     try {
//       // First API call - Parse the resume
//       const res = await dispatch(postResumePraising({ resume: resumeFile }));
//       console.log("ResponseResume", res);

//       if (res?.type === postResumePraising.fulfilled.type) {
//         openSnackbar("Resume parsed successfully!", "success");

//         // Wait for profile data to update
//         await new Promise(resolve => setTimeout(resolve, 1500));

//         // Now generate the AI resume after profile is updated
//         try {
//           handleInfo("Generating your AI resume...");

//           // Generate the PDF using the data from Redux
//           const pdfFile = await generateResumePDF();

//           if (pdfFile) {
//             // Save the generated resume to database
//             const formData = new FormData();
//             formData.append('file', pdfFile);
//             formData.append('section_slug', 'resume_details');

//             const saveResponse = await dispatch(postResumeReducer(formData));

//             if (saveResponse?.payload?.statusCode === 200) {
//               await dispatch(getResumeReducer());
//               handleInfo("AI Resume generated successfully!");
//               openSnackbar("AI Resume generated and saved!", "success");
//             } else {
//               openSnackbar("Failed to save generated resume", "error");
//             }
//           }
//         } catch (error) {
//           console.error("Failed to generate AI resume:", error);
//           openSnackbar("Resume parsed but AI generation failed", "error");
//         }

//         // Navigation logic
//         const isOnboarding = backLinkUrl?.includes('/onboarding');
//         const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
//         const hasOnboardingPath = isOnboarding || isUniversityOnboarding;

//         if (hasOnboardingPath) {
//           navigate("/verify-docs", {
//             state: { docType: 'Aadhaar' },
//             replace: true
//           });
//         } else if (checkType) {
//           let organizationId, id, userType;
//           const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
//           organizationId = params.get('organizationId');
//           id = params.get('id');
//           userType = params.get('type');
//           const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
//           window.location.replace(`${baseUrl}/?userType=${userType}`);
//           await dispatch(setDeeplinking(""));
//         } else if (CheckJob) {
//           const result = await dispatch(applyJob(jobId));
//           if (result?.payload?.statusCode === 200 || result?.payload?.statusCode === 201) {
//             openSnackbar("Successfully applied!", "success");
//             navigate("/home");
//             window.location.reload();
//           }
//         } else {
//           navigate("/home");
//           window.location.reload();
//         }
//       } else {
//         console.log('errrror', res);
//         openSnackbar("Failed to parse resume", "error");
//       }

//     } catch (error) {
//       console.error("Resume upload failed:", error);
//       openSnackbar("Unable to upload the resume right now. Please try again.", "error");
//     } finally {
//       setIsParsing(false);
//     }
//   };

//   const selectedFileLabel = resumeFile
//     ? `${resumeFile.name} - ${(resumeFile.size / (1024 * 1024)).toFixed(1)} MB`
//     : "PDF, DOC, or DOCX up to 10MB";

//   return (
//     <Box
//       sx={{
//         minHeight: "calc(100vh - 180px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         px: { xs: 2, sm: 3 },
//         py: { xs: 2, md: 4 },
//         backgroundColor: "#ffffff",
//       }}
//     >
//       <Paper
//         elevation={0}
//         sx={{
//           width: "100%",
//           maxWidth: 720,
//           borderRadius: 5,
//           overflow: "hidden",
//           backgroundColor: "#ffffff",
//           color: "#111827",
//           border: "1px solid rgba(0, 68, 198, 0.12)",
//           boxShadow: "0 20px 55px rgba(0, 68, 198, 0.12)",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             px: { xs: 2, sm: 3 },
//             pt: { xs: 2, sm: 2.5 },
//           }}
//         >
//           <IconButton
//             onClick={handleBack}
//             aria-label="Go back"
//             sx={{
//               color: "#0044C6",
//               bgcolor: "rgba(0, 68, 198, 0.06)",
//               "&:hover": { bgcolor: "rgba(0, 68, 198, 0.12)" },
//             }}
//           >
//             <ArrowBackRoundedIcon />
//           </IconButton>

//           <Button
//             onClick={handleSkip}
//             sx={{
//               color: "#0044C6",
//               fontWeight: 700,
//               fontSize: "0.98rem",
//               textTransform: "none",
//               minWidth: 0,
//               p: 0,
//               "&:hover": {
//                 backgroundColor: "transparent",
//                 opacity: 0.9,
//               },
//             }}
//           >
//             Skip
//           </Button>
//         </Box>

//         <Box
//           sx={{
//             px: { xs: 2, sm: 4, md: 6 },
//             pt: { xs: 2, sm: 3 },
//             pb: { xs: 2, sm: 4 },
//             textAlign: "center",
//           }}
//         >
//           <Box
//             sx={{
//               width: 92,
//               height: 92,
//               borderRadius: "50%",
//               display: "grid",
//               placeItems: "center",
//               mx: "auto",
//               mb: 2.5,
//               background: "rgba(0, 68, 198, 0.08)",
//               boxShadow: "inset 0 0 0 1px rgba(0, 68, 198, 0.12)",
//             }}
//           >
//             <CloudUploadOutlinedIcon sx={{ fontSize: 42, color: "#0044C6" }} />
//           </Box>

//           <Typography
//             variant="h4"
//             sx={{
//               fontSize: { xs: "1.55rem", sm: "2rem" },
//               fontWeight: 800,
//               lineHeight: 1.15,
//               mb: 1.5,
//               color: "#0f172a",
//             }}
//           >
//             Autofill Your Profile
//           </Typography>

//           <Typography
//             sx={{
//               color: "#475569",
//               maxWidth: 560,
//               mx: "auto",
//               fontSize: { xs: "0.98rem", sm: "1.05rem" },
//               lineHeight: 1.65,
//             }}
//           >
//             Upload your resume to automatically fill your profile, experience,
//             education, and skills in seconds.
//           </Typography>

//           <Box
//             onClick={() => fileInputRef.current?.click()}
//             onDragOver={(event) => {
//               event.preventDefault();
//               setIsDragging(true);
//             }}
//             onDragLeave={() => setIsDragging(false)}
//             onDrop={handleDrop}
//             sx={{
//               mt: { xs: 3, sm: 4 },
//               border: "1.8px dashed rgba(0, 68, 198, 0.35)",
//               borderRadius: 3,
//               minHeight: { xs: 170, sm: 190 },
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               px: 3,
//               py: 3,
//               cursor: "pointer",
//               backgroundColor: isDragging ? "rgba(0, 68, 198, 0.05)" : "#f8fbff",
//               transition: "all 180ms ease",
//               "&:hover": {
//                 borderColor: "#0044C6",
//                 backgroundColor: "#f1f7ff",
//               },
//             }}
//           >
//             <Box
//               sx={{
//                 width: 58,
//                 height: 58,
//                 borderRadius: "50%",
//                 display: "grid",
//                 placeItems: "center",
//                 mb: 1.5,
//                 backgroundColor: "rgba(0, 68, 198, 0.06)",
//               }}
//             >
//               <DescriptionOutlinedIcon sx={{ color: "#0044C6", fontSize: 30 }} />
//             </Box>

//             <Typography
//               sx={{
//                 color: "#0044C6",
//                 fontWeight: 800,
//                 fontSize: "1.05rem",
//                 lineHeight: 1.2,
//               }}
//             >
//               {resumeFile ? "Resume selected" : "Upload Resume"}
//             </Typography>

//             <Typography
//               sx={{
//                 color: "#64748b",
//                 fontSize: "0.92rem",
//                 mt: 0.5,
//                 textAlign: "center",
//               }}
//             >
//               {selectedFileLabel}
//             </Typography>

//             {resumeFile && (
//               <Box
//                 sx={{
//                   mt: 1.5,
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 0.8,
//                   color: "#0044C6",
//                   fontSize: "0.9rem",
//                   fontWeight: 600,
//                 }}
//               >
//                 <CheckCircleRoundedIcon sx={{ fontSize: 18 }} />
//                 Ready to upload
//               </Box>
//             )}

//             <input
//               ref={fileInputRef}
//               type="file"
//               hidden
//               accept=".pdf,.doc,.docx,.rtf"
//               onChange={handleFileChange}
//             />
//           </Box>

//           <Box
//             sx={{
//               mt: 2,
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <Typography
//               sx={{
//                 color: "#64748b",
//                 fontSize: "0.9rem",
//               }}
//             >
//               10MB max file size
//             </Typography>
//           </Box>

//           <Box
//             sx={{
//               mt: { xs: 4, sm: 5 },
//               display: "grid",
//               gap: 1.25,
//             }}
//           >
//             <Button
//               variant="contained"
//               onClick={handleParseResume}
//               disabled={isParsing}
//               sx={{
//                 py: 1.35,
//                 borderRadius: 2,
//                 background: "#0044C6",
//                 color: "#ffffff",
//                 fontWeight: 800,
//                 textTransform: "none",
//                 fontSize: "1rem",
//                 boxShadow: "none",
//                 "&:hover": {
//                   background: "#003aa9",
//                   boxShadow: "none",
//                 },
//                 "&.Mui-disabled": {
//                   color: "#ffffff",
//                   opacity: 0.72,
//                 },
//               }}
//             >
//               {isParsing ? "Uploading Resume..." : "Parse Resume"}
//             </Button>

//             <Button
//               variant="text"
//               onClick={handleSkip}
//               sx={{
//                 color: "#0044C6",
//                 textTransform: "none",
//                 fontWeight: 700,
//                 opacity: 0.82,
//                 "&:hover": {
//                   backgroundColor: "transparent",
//                   opacity: 1,
//                 },
//               }}
//             >
//               Skip for now
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default ActiveStep8;

// import React, { useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   IconButton,
//   Paper,
//   Typography,
// } from "@mui/material";
// import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
// import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
// import { useQuantityContext } from "../QuantityContext";
// import { useDispatch, useSelector } from "react-redux";
// import { postResumePraising, setDeeplinking } from "../../Redux/Reducers/OnboardingReducer";
// import { applyJob } from "../../Redux/Reducers/JobReducer";
// import { getCertificateReducer, getEducationReducer, getExperienceReducer, getPersonalProfileDataReducer, getProfessionalInfoReducer, getProfessionalSkillsReducer, getProjecteReducer, getResumeReducer, postResumeReducer } from "../../Redux/Reducers/ProfileReducer";
// import { useUserDetailContext } from "../../Components/UserDetailContext";

// const ActiveStep8 = ({ setActiveStep, onResumeUpload }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const fileInputRef = useRef(null);
//   const { openSnackbar, handleInfo } = useQuantityContext();
//   const { userDetails } = useUserDetailContext();
//   const [resumeFile, setResumeFile] = useState(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [isParsing, setIsParsing] = useState(false);

//   // Get all required data from Redux at the component level
//   const deeLinkURLPath = useSelector((state) => state?.onboarding?.deeplinkURL);
//   const ProfessionalData = useSelector((state) => state?.ProfileArray?.professionaProfile);
//   const ProfessonalSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_skills?.skills);
//   const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data);
//   const ProfessionalEducation = useSelector((state) => state?.ProfileArray?.educationData?.data);
//   const ProfessionalCertificate = useSelector((state) => state?.ProfileArray?.certificateData?.data);
//   const ProfessionalProject = useSelector((state) => state?.ProfileArray?.projectData?.data);
//   const ProfessonalSoftSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.soft_skills?.skills);
//   const ProfessonalToolsSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_tools?.skills);
//   const Personaldata = useSelector((state) => state?.ProfileArray?.personalProfile?.data);
//   const ProfessionalDataImage = useSelector((state) => state?.ProfileArray?.professionaProfile);

//   const backLinkUrl = deeLinkURLPath?.split('back_link_url=')?.[1];
//   const checkType = deeLinkURLPath?.includes('type');
//   const CheckJob = deeLinkURLPath?.includes('/job-description/');

//   const extractIdFromPath = (path) => {
//     if (!path) return null;
//     const segments = path.split('/');
//     return segments[segments.length - 1];
//   };

//   const jobId = extractIdFromPath(deeLinkURLPath);

//   const handleBack = () => {
//     if (typeof setActiveStep === "function") {
//       setActiveStep(3);
//       return;
//     }
//     navigate(-1);
//   };

//   const handleSkip = () => {
//     navigate("/home");
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files?.[0];
//     if (!file) return;
//     setResumeFile(file);
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     setIsDragging(false);
//     const file = event.dataTransfer.files?.[0];
//     if (!file) return;
//     setResumeFile(file);
//   };

//   // Helper functions for head tags and styles
//   const getHeadTags = (userDetail) => {
//     return `
//       <meta name="viewport" content="width=device-width, initial-scale=1" />
//       <title>${userDetail?.firstName || 'User'}'s Resume</title>
//     `;
//   };

//   const getResumeStyles = () => {
//     return `
//       .profile-resume {color: rgb(0, 0, 0, 0.87); font-family: 'Lato', sans-serif; font-size: 11pt; display: flex; flex-direction: row; }
//       .profile-resume .resume-side-content { flex: 0 0 30%; background-color: #F7F9FC; padding: 20px; height: 100vh; min-height: 100vh; }
//       .profile-resume .resume-main-body { flex: 0 0 70%; background-color: #ffffff; padding: 24px 16px 24px 16px; position: relative; }
//       .resume-main-section { padding-bottom: 20px; padding-left: 20px; }
//       .resume-main-body-wrapper .drag-item:not(:last-child) .resume-main-section { border-left: 1px solid #E2E6EE; }
//       .resume-side-content .resume-header .resume-profile-container { height: 4rem; width: 4rem; border-radius: 50%; overflow: hidden; }
//       .resume-profile-name { font-size: 12pt; font-weight: 700; }
//       .resume-profile-headline { font-weight: 700; color: rgba(0, 0, 0, 0.60); }
//       .resume-side-content .resume-divider { background-color: #EDF0F5; height: 1px; width: 100%; margin: 1rem 0; }
//       .resume-side-content .resume-contact-list { display: flex; flex-direction: column; gap: 0.5rem; }
//       .resume-contact-list a { text-decoration: none; color: unset; }
//       .resume-contact-item { display: flex; align-items: center; gap: 0.5rem; }
//       .resume-contact-icon-container { border-radius: 50%; height: 24px; width: 24px; background-color: #E2E6EE; display: flex; justify-content: center; align-items: center; }
//       .resume-contact-id { font-size: 11pt; color: rgb(0, 0, 0, 0.87); }
//       .resume-section-title::before { content: '•'; height: 1.5rem; width: 1.5rem; background-color: white; position: absolute; left: -30px; top: -4px;
//         border-radius: 50%; display: flex; align-items: center; justify-content: center;
//         color: purple; font-size: 14pt; }
//       .resume-main-section .resume-section-title { font-size: 12.5pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 1rem; position: relative; }
//       .resume-project-section .resume-section-body { display: grid; grid-template-columns: repeat(2, 1fr); gap: 4px; }
//       .resume-project-section .resume-section-item { display: flex; flex-direction: column; gap: 8px; padding: 10px; background-color: #F7F9FC; border-radius: 4px; overflow: hidden; }
//       .resume-project-title { font-size: 11pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 4px; }
//       .resume-project-desc { font-size: 10pt; color: rgba(0, 0, 0, 0.60); line-break: pre-line; white-space: pre-line; }
//       .resume-experience-section .resume-section-body { padding-left: 20px; display: flex; flex-direction: column; }
//       .resume-experience-section .resume-section-item { display: flex; flex-direction: column; gap: 6px; padding: 4px 0 8px; overflow: hidden; color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
//       .resume-experience-section .resume-section-item:not(:last-child) { border-bottom: 0.7px solid lightgray; }
//       .resume-exp-content-left .exp-time-location { margin-bottom: 0.25rem; padding-left: 12px; position: relative; }
//       .resume-exp-content-left .exp-time-location::before { content: ''; height: 4px; width: 4px; background-color: black; position: absolute; left: 0; top: 4px; border-radius: 50%; }
//       .resume-exp-content-left .exp-name-logo { display: flex; gap: 8px; align-items: center; padding-left: 12px; border-left: 1px solid #F7F9FC; margin-left: 1px; }
//       .exp-name-logo .resume-exp-logo { height: 34px; width: 34px; overflow: hidden; }
//       .resume-exp-logo img { height: 100%; width: 100%; object-fit: contain; }
//       .resume-exp-name .resume-exp-designation { color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
//       .resume-exp-name .resume-exp-company { color: rgb(0, 0, 0, 0.87); font-size: 11pt; }
//       .resume-exp-location { display: inline-flex; align-items: center; }
//       .resume-exp-icon { height: 14px; width: 14px; margin-right: 2px; }
//       .resume-education-section .resume-section-body { display: flex; flex-wrap: wrap; gap: 4px; }
//       .resume-education-section .resume-section-item { flex: 0 0 30%; border-radius: 4px; padding: 6px 12px; background-color: #F7F9FC; display: flex; flex-direction: column; gap: 4px; font-size: 10pt; max-width: 32%; }
//       .resume-section-item .edu-name-logo { display: flex; align-items: center; gap: 4px; }
//       .resume-section-item .edu-name-logo img { height: 28px; width: 28px; object-fit: contain; overflow: hidden; }
//       .resume-section-item .edu-degree-time .resume-edu-degree { font-size: 10pt; font-weight: 700; margin-bottom: 1px; }
//       .resume-section-item .edu-degree-time .resume-edu-time { color: rgba(0, 0, 0, 0.60); }
//       .resume-skills-section .resume-section-body { display: flex; flex-direction: column; gap: 8px; }
//       .resume-skills-row { display: flex; gap: 8px; flex-wrap: wrap; flex: 0 0 68%; }
//       .resume-skills-row .resume-section-item { border-radius: 4px; padding: 6px 4px; background-color: #F7F9FC; max-width: 70%; overflow: hidden; display: flex; align-items: center; }
//       .resume-tools-section .resume-section-body { display: flex; }
//       .resume-section-body .resume-skills-row.resume-tools-row { flex: 0 0 90%; max-width: 90%; }
//       .contain-image { height: 100%; width: 100%; object-fit: contain; }
//       .cover-image { height: 100%; width: 100%; object-fit: cover; }
//       .d-flex { display: flex !important; }
//       .flex-column { flex-direction: column !important; }
//       .gap-2 { gap: 0.5rem; }
//       .word-break { word-break: break-word; }
//       .line-break { white-space: pre-line; }
//       .ps-3 {padding-left: 1rem}
//       .py-2 {padding-top: .5rem !important;padding-bottom: .5rem !important;}
//       .me-1 { margin-right: 0.25rem; }
//       .mb-1 { margin-bottom: 0.25rem; }
//       .mb-2 { margin-bottom: 0.5rem; }
//       @page { size: A4; margin: 2mm 2mm 2mm 2mm; }
//       * { box-sizing: border-box; }
//     `;
//   };

//   // Helper function to create the HTML for the resume
//   const createResumeHTML = (
//     profData,
//     profSkills,
//     profExperience,
//     profEducation,
//     profCertificate,
//     profProject,
//     softSkills,
//     toolsSkills,
//     userDetail,
//     personalData,
//     profImageData
//   ) => {
//     const tempDiv = document.createElement('div');
//     tempDiv.className = 'profile-resume';

//     // Side content
//     const sideContent = document.createElement('section');
//     sideContent.className = 'resume-side-content';

//     sideContent.innerHTML = `
//       <div class="resume-header mb-3">
//         <div class="resume-profile-container mb-2">
//           <img src="${profImageData?.user_profile_url || userDetail?.proFile || ''}" alt="${userDetail?.firstName || 'User'}" class="cover-image" />
//         </div>
//         <div class="resume-profile-name">${userDetail?.firstName || ''} ${userDetail?.lastName || ''}</div>
//         <div class="resume-profile-headline">${profData?.designation || ''}</div>
//       </div>
//       <div class="resume-divider" />
//       <div class="resume-contact-list">
//         <a href="mailto:${userDetail?.email || ''}" target="_blank" rel="noreferrer">
//           <div class="resume-contact-item">
//             <div class="resume-contact-icon-container"><span>📧</span></div>
//             <div>
//               <div class="resume-contact-label">Email</div>
//               <div class="resume-contact-id">${userDetail?.email || ''}</div>
//             </div>
//           </div>
//         </a>
//         <a href="tel:${userDetail?.phone || ''}" target="_blank" rel="noreferrer">
//           <div class="resume-contact-item">
//             <div class="resume-contact-icon-container"><span>📞</span></div>
//             <div>
//               <div class="resume-contact-label">Phone</div>
//               <div class="resume-contact-id">${userDetail?.phone || ''}</div>
//             </div>
//           </div>
//         </a>
//       </div>
//     `;
//     tempDiv.appendChild(sideContent);

//     // Main body with sections
//     const mainBody = document.createElement('section');
//     mainBody.className = 'resume-main-body';
//     let sectionsHTML = '';

//     // 1. Add Summary section if exists
//     if (profData?.about_me) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-section-title">Summary</div>
//           <div>
//             <div class="resume-project-desc line-break">${profData.about_me}</div>
//           </div>
//         </section>
//       `;
//     }

//     // 2. Add Projects section
//     if (profProject && profProject.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-project-section">
//             <div class="resume-section-title">Projects</div>
//             <div class="resume-section-body">
//               ${profProject.map(project => `
//                 <div class="resume-section-item">
//                   <div class="resume-project-item">
//                     <div class="resume-project-title">${project?.project_name || ''}</div>
//                     <div class="resume-project-desc line-break">${project?.project_description || ''}</div>
//                   </div>
//                 </div>
//               `).join('')}
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     // 3. Add Experience section
//     if (profExperience && profExperience.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-experience-section">
//             <div class="resume-section-title">Experience</div>
//             <div class="resume-section-body">
//               ${profExperience.map(exp => `
//                 <div class="resume-section-item">
//                   <div class="resume-exp-content-left">
//                     <div class="exp-time-location">
//                       <span class="me-1">
//                         ${exp?.start_month || ''} ${exp?.start_year || ''} -
//                         ${exp?.is_currently_working ? 'Present' : `${exp?.end_month || ''} ${exp?.end_year || ''}`}
//                       </span>
//                       ${exp?.location ? `
//                         <span class="resume-exp-location">
//                           📍 <span>${exp?.location} ${exp?.location_type ? '• ' + exp?.location_type : ''}</span>
//                         </span>
//                       ` : ''}
//                     </div>
//                     <div class="exp-name-logo">
//                       ${exp?.company_logo ? `
//                         <div class="resume-exp-logo">
//                           <img src="${exp.company_logo}" alt="logo" class="contain-image" />
//                         </div>
//                       ` : ''}
//                       <div class="resume-exp-name">
//                         <div class="resume-exp-designation">${exp?.role_title || ''}</div>
//                         <div class="resume-exp-company">${exp?.company_name || ''}</div>
//                       </div>
//                     </div>
//                   </div>
//                   ${exp?.details ? `
//                     <div class="resume-project-desc line-break ps-3 py-2">
//                       ${exp.details}
//                     </div>
//                   ` : ''}
//                   ${exp?.responsibility ? `
//                     <div class="resume-project-desc line-break ps-3 py-2">
//                       ${exp.responsibility}
//                     </div>
//                   ` : ''}
//                 </div>
//               `).join('')}
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     // 4. Add Education section
//     if (profEducation && profEducation.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-education-section">
//             <div class="resume-section-title">Education</div>
//             <div class="resume-section-body">
//               ${profEducation.map(edu => `
//                 <div class="resume-section-item">
//                   <div class="edu-name-logo">
//                     ${edu?.logo_link ? `<img src="${edu.logo_link}" alt="Institute Logo" />` : ''}
//                     <div>${edu?.institute_name || ''}</div>
//                   </div>
//                   <div class="edu-degree-time">
//                     <div class="resume-edu-degree">
//                       ${edu?.degree || edu?.educational_level || ''}
//                     </div>
//                     <div class="resume-edu-time">
//                       ${edu?.start_year || ''} - ${edu?.is_pursuing ? 'Present' : edu?.end_year || ''}
//                     </div>
//                   </div>
//                 </div>
//               `).join('')}
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     // 5. Add Certificate section
//     if (profCertificate && profCertificate.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-education-section">
//             <div class="resume-section-title">Certificates</div>
//             <div class="resume-section-body">
//               ${profCertificate.map(cert => `
//                 <div class="resume-section-item">
//                   <div class="edu-name-logo">
//                     ${cert?.certificate_logo ? `<img src="${cert.certificate_logo}" alt="Certificate Logo" />` : ''}
//                     <div>${cert?.course_name || ''}</div>
//                   </div>
//                   <div class="edu-degree-time">
//                     <div class="resume-edu-degree">
//                       ${cert?.organisation_name || ''}
//                     </div>
//                     <div class="resume-edu-time">
//                       ${cert?.issue_date || ''} ${cert?.year || ''}
//                     </div>
//                   </div>
//                 </div>
//               `).join('')}
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     // 6. Add Skills sections
//     if (softSkills && softSkills.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-skills-section">
//             <div class="resume-section-title">Soft Skills</div>
//             <div class="resume-section-body">
//               <div class="d-flex flex-column gap-2">
//                 <div class="resume-skills-row">
//                   ${softSkills.map(skill => `
//                     <div class="resume-section-item word-break">${skill}</div>
//                   `).join('')}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     if (profSkills && profSkills.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-skills-section">
//             <div class="resume-section-title">Professional Skills</div>
//             <div class="resume-section-body">
//               <div class="d-flex flex-column gap-2">
//                 <div class="resume-skills-row">
//                   ${profSkills.map(skill => `
//                     <div class="resume-section-item word-break">${skill}</div>
//                   `).join('')}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     if (toolsSkills && toolsSkills.length > 0) {
//       sectionsHTML += `
//         <section class="resume-main-section">
//           <div class="resume-tools-section">
//             <div class="resume-section-title">Tools</div>
//             <div class="resume-section-body">
//               <div class="resume-skills-row resume-tools-row">
//                 ${toolsSkills.map(tool => `
//                   <div class="resume-section-item word-break">${tool}</div>
//                 `).join('')}
//               </div>
//             </div>
//           </div>
//         </section>
//       `;
//     }

//     mainBody.innerHTML = sectionsHTML;
//     tempDiv.appendChild(mainBody);

//     return tempDiv.outerHTML;
//   };

//   // Function to generate PDF
//   // const generateResumePDF = async () => {
//   //   try {
//   //     // Create the resume HTML using the data from Redux
//   //     const resumeHTML = createResumeHTML(
//   //       ProfessionalData,
//   //       ProfessonalSkills,
//   //       ProfessionalExperience,
//   //       ProfessionalEducation,
//   //       ProfessionalCertificate,
//   //       ProfessionalProject,
//   //       ProfessonalSoftSkills,
//   //       ProfessonalToolsSkills,
//   //       userDetails,
//   //       Personaldata,
//   //       ProfessionalDataImage
//   //     );

//   //     // Log to debug what data is being used
//   //     console.log("ProfessionalData:", ProfessionalData);
//   //     console.log("ProfessionalExperience:", ProfessionalExperience);
//   //     console.log("ProfessionalEducation:", ProfessionalEducation);
//   //     console.log("ProfessionalProject:", ProfessionalProject);
//   //     console.log("ProfessionalCertificate:", ProfessionalCertificate);

//   //     // Call the backend to generate PDF
//   //     const accessToken = localStorage.getItem("objectId");
//   //     const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/generate-pdf/resume-pdf`, {
//   //       method: 'POST',
//   //       headers: {
//   //         Authorization: `Bearer ${accessToken}`,
//   //         'Content-Type': 'application/json',
//   //       },
//   //       body: JSON.stringify({ 
//   //         headTags: getHeadTags(userDetails),
//   //         resumeStyles: getResumeStyles(),
//   //         htmlContent: resumeHTML 
//   //       }),
//   //     });

//   //     if (!response.ok) {
//   //       throw new Error(`Failed to generate PDF: ${response.statusText}`);
//   //     }

//   //     const pdfBuffer = await response.blob();

//   //     if (pdfBuffer.size < 1024) {
//   //       throw new Error('Generated PDF file is too small and may be corrupted.');
//   //     }

//   //     // Create a file from the blob
//   //     const file = new File(
//   //       [pdfBuffer], 
//   //       `${userDetails?.firstName || 'User'} Resume-${Date.now()}.pdf`, 
//   //       { type: 'application/pdf' }
//   //     );

//   //     return file;
//   //   } catch (error) {
//   //     console.error('Error generating PDF:', error);
//   //     return null;
//   //   }
//   // };

//   // Function to generate PDF
// const generateResumePDF = async () => {
//   try {
//     // Get fresh data from Redux for the PDF generation
//     const profData = ProfessionalData;
//     const profSkills = ProfessonalSkills;
//     const profExperience = ProfessionalExperience;
//     const profEducation = ProfessionalEducation;
//     const profCertificate = ProfessionalCertificate;
//     const profProject = ProfessionalProject;
//     const softSkills = ProfessonalSoftSkills;
//     const toolsSkills = ProfessonalToolsSkills;

//     console.log("Generating PDF with data:", {
//       hasExperience: profExperience?.length || 0,
//       hasEducation: profEducation?.length || 0,
//       hasProjects: profProject?.length || 0,
//       hasCertificates: profCertificate?.length || 0,
//       hasSoftSkills: softSkills?.length || 0,
//       hasProfSkills: profSkills?.length || 0
//     });

//     // Create the resume HTML using the data from Redux
//     const resumeHTML = createResumeHTML(
//       profData,
//       profSkills,
//       profExperience,
//       profEducation,
//       profCertificate,
//       profProject,
//       softSkills,
//       toolsSkills,
//       userDetails,
//       Personaldata,
//       ProfessionalDataImage
//     );

//     // Call the backend to generate PDF
//     const accessToken = localStorage.getItem("objectId");
//     const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/generate-pdf/resume-pdf`, {
//       method: 'POST',
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ 
//         headTags: getHeadTags(userDetails),
//         resumeStyles: getResumeStyles(),
//         htmlContent: resumeHTML 
//       }),
//     });

//     if (!response.ok) {
//       throw new Error(`Failed to generate PDF: ${response.statusText}`);
//     }

//     const pdfBuffer = await response.blob();

//     if (pdfBuffer.size < 1024) {
//       throw new Error('Generated PDF file is too small and may be corrupted.');
//     }

//     // Create a file from the blob
//     const file = new File(
//       [pdfBuffer], 
//       `${userDetails?.firstName || 'User'} Resume-${Date.now()}.pdf`, 
//       { type: 'application/pdf' }
//     );

//     return file;
//   } catch (error) {
//     console.error('Error generating PDF:', error);
//     return null;
//   }
// };

//   // const handleParseResume = async () => {
//   //   if (!resumeFile) {
//   //     openSnackbar("Upload a resume first, or use Skip to continue.", "info");
//   //     return;
//   //   }

//   //   setIsParsing(true);
//   //   handleInfo("Uploading your resume...");

//   //   try {
//   //     // First API call - Parse the resume
//   //     const res = await dispatch(postResumePraising({ resume: resumeFile }));
//   //     console.log("ResponseResume", res);

//   //     if (res?.type === postResumePraising.fulfilled.type) {
//   //       openSnackbar("Resume parsed successfully!", "success");

//   //       // Wait for profile data to update
//   //       await new Promise(resolve => setTimeout(resolve, 2000));

//   //       // Now generate the AI resume after profile is updated
//   //       try {
//   //         handleInfo("Generating your AI resume...");

//   //         // Generate the PDF using the data from Redux
//   //         const pdfFile = await generateResumePDF();

//   //         if (pdfFile) {
//   //           // Save the generated resume to database
//   //           const formData = new FormData();
//   //           formData.append('file', pdfFile);
//   //           formData.append('section_slug', 'resume_details');

//   //           const saveResponse = await dispatch(postResumeReducer(formData));

//   //           if (saveResponse?.payload?.statusCode === 200) {
//   //             await dispatch(getResumeReducer());
//   //             handleInfo("AI Resume generated successfully!");
//   //             openSnackbar("AI Resume generated and saved!", "success");
//   //           } else {
//   //             openSnackbar("Failed to save generated resume", "error");
//   //           }
//   //         }
//   //       } catch (error) {
//   //         console.error("Failed to generate AI resume:", error);
//   //         openSnackbar("Resume parsed but AI generation failed", "error");
//   //       }

//   //       // Navigation logic
//   //       const isOnboarding = backLinkUrl?.includes('/onboarding');
//   //       const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
//   //       const hasOnboardingPath = isOnboarding || isUniversityOnboarding;

//   //       if (hasOnboardingPath) {
//   //         navigate("/verify-docs", {
//   //           state: { docType: 'Aadhaar' },
//   //           replace: true
//   //         });
//   //       } else if (checkType) {
//   //         let organizationId, id, userType;
//   //         const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
//   //         organizationId = params.get('organizationId');
//   //         id = params.get('id');
//   //         userType = params.get('type');
//   //         const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
//   //         window.location.replace(`${baseUrl}/?userType=${userType}`);
//   //         await dispatch(setDeeplinking(""));
//   //       } else if (CheckJob) {
//   //         const result = await dispatch(applyJob(jobId));
//   //         if (result?.payload?.statusCode === 200 || result?.payload?.statusCode === 201) {
//   //           openSnackbar("Successfully applied!", "success");
//   //           navigate("/home");
//   //           window.location.reload();
//   //         }
//   //       } else {
//   //         navigate("/home");
//   //         window.location.reload();
//   //       }
//   //     } else {
//   //       console.log('errrror', res);
//   //       openSnackbar("Failed to parse resume", "error");
//   //     }

//   //   } catch (error) {
//   //     console.error("Resume upload failed:", error);
//   //     openSnackbar("Unable to upload the resume right now. Please try again.", "error");
//   //   } finally {
//   //     setIsParsing(false);
//   //   }
//   // };

// const handleParseResume = async () => {
//   if (!resumeFile) {
//     openSnackbar("Upload a resume first, or use Skip to continue.", "info");
//     return;
//   }

//   setIsParsing(true);
//   handleInfo("Uploading your resume...");

//   try {
//     // First API call - Parse the resume
//     const res = await dispatch(postResumePraising({ resume: resumeFile }));
//     console.log("ResponseResume", res);

//     if (res?.type === postResumePraising.fulfilled.type) {
//       openSnackbar("Resume parsed successfully!", "success");

//       // IMPORTANT: Fetch all updated data after parsing
//       handleInfo("Fetching updated profile data...");

//       // Wait and fetch all updated data
//       await new Promise(resolve => setTimeout(resolve, 1000));

//       // Fetch all updated data from Redux - Import these actions at the top
//       await dispatch(getProfessionalInfoReducer());
//       await dispatch(getPersonalProfileDataReducer()); 
//       await dispatch(getExperienceReducer());
//       await dispatch(getEducationReducer());
//       await dispatch(getCertificateReducer());
//       await dispatch(getProjecteReducer());
//       await dispatch(getProfessionalSkillsReducer());

//       // Wait a bit more for data to be available in Redux
//       await new Promise(resolve => setTimeout(resolve, 1500));

//       // Now generate the AI resume after profile is updated
//       try {
//         handleInfo("Generating your AI resume...");

//         // Generate the PDF using the data from Redux
//         const pdfFile = await generateResumePDF();

//         if (pdfFile) {
//           // Save the generated resume to database
//           const formData = new FormData();
//           formData.append('file', pdfFile);
//           formData.append('section_slug', 'resume_details');

//           const saveResponse = await dispatch(postResumeReducer(formData));

//           if (saveResponse?.payload?.statusCode === 200) {
//             await dispatch(getResumeReducer());
//             handleInfo("AI Resume generated successfully!");
//             openSnackbar("AI Resume generated and saved!", "success");
//           } else {
//             openSnackbar("Failed to save generated resume", "error");
//           }
//         }
//       } catch (error) {
//         console.error("Failed to generate AI resume:", error);
//         openSnackbar("Resume parsed but AI generation failed", "error");
//       }

//       // Navigation logic
//       const isOnboarding = backLinkUrl?.includes('/onboarding');
//       const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
//       const hasOnboardingPath = isOnboarding || isUniversityOnboarding;

//       if (hasOnboardingPath) {
//         navigate("/verify-docs", {
//           state: { docType: 'Aadhaar' },
//           replace: true
//         });
//       } else if (checkType) {
//         let organizationId, id, userType;
//         const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
//         organizationId = params.get('organizationId');
//         id = params.get('id');
//         userType = params.get('type');
//         const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
//         window.location.replace(`${baseUrl}/?userType=${userType}`);
//         await dispatch(setDeeplinking(""));
//       } else if (CheckJob) {
//         const result = await dispatch(applyJob(jobId));
//         if (result?.payload?.statusCode === 200 || result?.payload?.statusCode === 201) {
//           openSnackbar("Successfully applied!", "success");
//           // navigate("/home");
//           // window.location.reload();
//         }
//       } else {
//         navigate("/home");
//         window.location.reload();
//       }
//     } else {
//       console.log('errrror', res);
//       openSnackbar("Failed to parse resume", "error");
//     }

//   } catch (error) {
//     console.error("Resume upload failed:", error);
//     openSnackbar("Unable to upload the resume right now. Please try again.", "error");
//   } finally {
//     setIsParsing(false);
//   }
// };

//   const selectedFileLabel = resumeFile
//     ? `${resumeFile.name} - ${(resumeFile.size / (1024 * 1024)).toFixed(1)} MB`
//     : "PDF, DOC, or DOCX up to 10MB";

//   return (
//     <Box
//       sx={{
//         minHeight: "calc(100vh - 180px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         px: { xs: 2, sm: 3 },
//         py: { xs: 2, md: 4 },
//         backgroundColor: "#ffffff",
//       }}
//     >
//       <Paper
//         elevation={0}
//         sx={{
//           width: "100%",
//           maxWidth: 720,
//           borderRadius: 5,
//           overflow: "hidden",
//           backgroundColor: "#ffffff",
//           color: "#111827",
//           border: "1px solid rgba(0, 68, 198, 0.12)",
//           boxShadow: "0 20px 55px rgba(0, 68, 198, 0.12)",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             px: { xs: 2, sm: 3 },
//             pt: { xs: 2, sm: 2.5 },
//           }}
//         >
//           <IconButton
//             onClick={handleBack}
//             aria-label="Go back"
//             sx={{
//               color: "#0044C6",
//               bgcolor: "rgba(0, 68, 198, 0.06)",
//               "&:hover": { bgcolor: "rgba(0, 68, 198, 0.12)" },
//             }}
//           >
//             <ArrowBackRoundedIcon />
//           </IconButton>

//           <Button
//             onClick={handleSkip}
//             sx={{
//               color: "#0044C6",
//               fontWeight: 700,
//               fontSize: "0.98rem",
//               textTransform: "none",
//               minWidth: 0,
//               p: 0,
//               "&:hover": {
//                 backgroundColor: "transparent",
//                 opacity: 0.9,
//               },
//             }}
//           >
//             Skip
//           </Button>
//         </Box>

//         <Box
//           sx={{
//             px: { xs: 2, sm: 4, md: 6 },
//             pt: { xs: 2, sm: 3 },
//             pb: { xs: 2, sm: 4 },
//             textAlign: "center",
//           }}
//         >
//           <Box
//             sx={{
//               width: 92,
//               height: 92,
//               borderRadius: "50%",
//               display: "grid",
//               placeItems: "center",
//               mx: "auto",
//               mb: 2.5,
//               background: "rgba(0, 68, 198, 0.08)",
//               boxShadow: "inset 0 0 0 1px rgba(0, 68, 198, 0.12)",
//             }}
//           >
//             <CloudUploadOutlinedIcon sx={{ fontSize: 42, color: "#0044C6" }} />
//           </Box>

//           <Typography
//             variant="h4"
//             sx={{
//               fontSize: { xs: "1.55rem", sm: "2rem" },
//               fontWeight: 800,
//               lineHeight: 1.15,
//               mb: 1.5,
//               color: "#0f172a",
//             }}
//           >
//             Autofill Your Profile
//           </Typography>

//           <Typography
//             sx={{
//               color: "#475569",
//               maxWidth: 560,
//               mx: "auto",
//               fontSize: { xs: "0.98rem", sm: "1.05rem" },
//               lineHeight: 1.65,
//             }}
//           >
//             Upload your resume to automatically fill your profile, experience,
//             education, and skills in seconds.
//           </Typography>

//           <Box
//             onClick={() => fileInputRef.current?.click()}
//             onDragOver={(event) => {
//               event.preventDefault();
//               setIsDragging(true);
//             }}
//             onDragLeave={() => setIsDragging(false)}
//             onDrop={handleDrop}
//             sx={{
//               mt: { xs: 3, sm: 4 },
//               border: "1.8px dashed rgba(0, 68, 198, 0.35)",
//               borderRadius: 3,
//               minHeight: { xs: 170, sm: 190 },
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               px: 3,
//               py: 3,
//               cursor: "pointer",
//               backgroundColor: isDragging ? "rgba(0, 68, 198, 0.05)" : "#f8fbff",
//               transition: "all 180ms ease",
//               "&:hover": {
//                 borderColor: "#0044C6",
//                 backgroundColor: "#f1f7ff",
//               },
//             }}
//           >
//             <Box
//               sx={{
//                 width: 58,
//                 height: 58,
//                 borderRadius: "50%",
//                 display: "grid",
//                 placeItems: "center",
//                 mb: 1.5,
//                 backgroundColor: "rgba(0, 68, 198, 0.06)",
//               }}
//             >
//               <DescriptionOutlinedIcon sx={{ color: "#0044C6", fontSize: 30 }} />
//             </Box>

//             <Typography
//               sx={{
//                 color: "#0044C6",
//                 fontWeight: 800,
//                 fontSize: "1.05rem",
//                 lineHeight: 1.2,
//               }}
//             >
//               {resumeFile ? "Resume selected" : "Upload Resume"}
//             </Typography>

//             <Typography
//               sx={{
//                 color: "#64748b",
//                 fontSize: "0.92rem",
//                 mt: 0.5,
//                 textAlign: "center",
//               }}
//             >
//               {selectedFileLabel}
//             </Typography>

//             {resumeFile && (
//               <Box
//                 sx={{
//                   mt: 1.5,
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 0.8,
//                   color: "#0044C6",
//                   fontSize: "0.9rem",
//                   fontWeight: 600,
//                 }}
//               >
//                 <CheckCircleRoundedIcon sx={{ fontSize: 18 }} />
//                 Ready to upload
//               </Box>
//             )}

//             <input
//               ref={fileInputRef}
//               type="file"
//               hidden
//               accept=".pdf,.doc,.docx,.rtf"
//               onChange={handleFileChange}
//             />
//           </Box>

//           <Box
//             sx={{
//               mt: 2,
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <Typography
//               sx={{
//                 color: "#64748b",
//                 fontSize: "0.9rem",
//               }}
//             >
//               10MB max file size
//             </Typography>
//           </Box>

//           <Box
//             sx={{
//               mt: { xs: 4, sm: 5 },
//               display: "grid",
//               gap: 1.25,
//             }}
//           >
//             <Button
//               variant="contained"
//               onClick={handleParseResume}
//               disabled={isParsing}
//               sx={{
//                 py: 1.35,
//                 borderRadius: 2,
//                 background: "#0044C6",
//                 color: "#ffffff",
//                 fontWeight: 800,
//                 textTransform: "none",
//                 fontSize: "1rem",
//                 boxShadow: "none",
//                 "&:hover": {
//                   background: "#003aa9",
//                   boxShadow: "none",
//                 },
//                 "&.Mui-disabled": {
//                   color: "#ffffff",
//                   opacity: 0.72,
//                 },
//               }}
//             >
//               {isParsing ? "Uploading Resume..." : "Parse Resume"}
//             </Button>

//             <Button
//               variant="text"
//               onClick={handleSkip}
//               sx={{
//                 color: "#0044C6",
//                 textTransform: "none",
//                 fontWeight: 700,
//                 opacity: 0.82,
//                 "&:hover": {
//                   backgroundColor: "transparent",
//                   opacity: 1,
//                 },
//               }}
//             >
//               Skip for now
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default ActiveStep8;

import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { useQuantityContext } from "../QuantityContext";
import { useDispatch, useSelector } from "react-redux";
import { postResumePraising, setDeeplinking } from "../../Redux/Reducers/OnboardingReducer";
import { applyJob } from "../../Redux/Reducers/JobReducer";
import {
  getCertificateReducer,
  getEducationReducer,
  getExperienceReducer,
  getPersonalProfileDataReducer,
  getProfessionalInfoReducer,
  getProfessionalSkillsReducer,
  getProjecteReducer,
  getResumeReducer,
  postResumeReducer
} from "../../Redux/Reducers/ProfileReducer";
import { useUserDetailContext } from "../../Components/UserDetailContext";
import axios from "axios";
import { getKycOcrApiReducer, getKycPanOcrApiReducer } from "../../Redux/Reducers/KycReducer";

const ActiveStep8 = ({ setActiveStep, onResumeUpload }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const { openSnackbar, handleInfo } = useQuantityContext();
  const { userDetails } = useUserDetailContext();
  const [resumeFile, setResumeFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isParsing, setIsParsing] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const deeLinkURLPath = useSelector((state) => state?.onboarding?.deeplinkURL);
  const backLinkUrl = deeLinkURLPath?.split('back_link_url=')?.[1];
  const checkType = deeLinkURLPath?.includes('type');
  const CheckJob = deeLinkURLPath?.includes('/job-description/');
  const isUserData = localStorage.getItem("userDetails")

  // Check if userData exists and is not empty
  const hasUserData = isUserData !== null && isUserData !== "" && isUserData !== "null" && isUserData !== "undefined"

  const extractIdFromPath = (path) => {
    if (!path) return null;
    const segments = path.split('/');
    return segments[segments.length - 1];
  };

  const jobId = extractIdFromPath(deeLinkURLPath);

  // Get data from Redux - these will be updated after parsing
  const ProfessionalData = useSelector((state) => state?.ProfileArray?.professionaProfile);
  const ProfessonalSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_skills?.skills);
  const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data);
  const ProfessionalEducation = useSelector((state) => state?.ProfileArray?.educationData?.data);
  const ProfessionalCertificate = useSelector((state) => state?.ProfileArray?.certificateData?.data);
  const ProfessionalProject = useSelector((state) => state?.ProfileArray?.projectData?.data);
  const ProfessonalSoftSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.soft_skills?.skills);
  const ProfessonalToolsSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_tools?.skills);
  const Personaldata = useSelector((state) => state?.ProfileArray?.personalProfile?.data);
  const ProfessionalDataImage = useSelector((state) => state?.ProfileArray?.professionaProfile);
  const Resumedata = useSelector((state) => state?.ProfileArray?.ResumeData?.data);
  // console.log("BLAAAAAAAA1233", ProfessionalData, ProfessonalSkills, ProfessionalExperience, ProfessionalEducation, ProfessionalCertificate, ProfessionalProject, ProfessonalSoftSkills, ProfessonalToolsSkills, Personaldata)
  // console.log("ProfessionalExperienceBBBB", ProfessionalExperience, ProfessionalEducation)
  const handleBack = () => {
    if (typeof setActiveStep === "function") {
      setActiveStep(3);
      return;
    }
    navigate(-1);
  };

  const handleSkip = () => {
    navigate("/home");
    window.location.reload();
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setResumeFile(file);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files?.[0];
    if (!file) return;
    setResumeFile(file);
  };

  // Helper function to convert image to base64 (from ResumeGenerate)
  const convertImageToBase64 = (imgElement) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = imgElement.src;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };

      img.onerror = () => {
        reject(new Error('Failed to convert image to base64'));
      };
    });
  };

  // Function to generate the resume PDF - copied from ResumeGenerate
  const generateResumePDF = async () => {
    try {
      // Get the latest data from Redux
      const profData = ProfessionalData || {};
      const profSkills = ProfessonalSkills || [];
      const profExperience = ProfessionalExperience || [];
      const profEducation = ProfessionalEducation || [];
      const profCertificate = ProfessionalCertificate || [];
      const profProject = ProfessionalProject || [];
      const softSkills = ProfessonalSoftSkills || [];
      const toolsSkills = ProfessonalToolsSkills || [];
      const personalData = Personaldata || {};
      const profImageData = ProfessionalDataImage || {};

      // Sort experiences and education by date
      const sortedExperience = [...profExperience].sort((a, b) => {
        const dateA = new Date(a?.start_year || 0, a?.start_month || 0);
        const dateB = new Date(b?.end_year || 0, b?.end_month || 0);
        return dateB - dateA;
      });

      const sortedEducation = [...profEducation].sort((a, b) => {
        const dateA = new Date(a?.start_year || 0);
        const dateB = new Date(b?.end_year || 0);
        return dateB - dateA;
      });
      // console.log("sortedExperience", sortedExperience, "sortedEducation", sortedEducation)
      // Create the resume HTML
      const resumeHTML = createResumeHTML(
        profData,
        profSkills,
        sortedExperience || profExperience,
        sortedEducation || profEducation,
        profCertificate,
        profProject,
        softSkills,
        toolsSkills,
        userDetails,
        personalData,
        profImageData
      );

      // Get head tags and styles
      const headTags = `
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>${userDetails?.firstName || 'User'}'s Resume</title>
      `;

      const resumeStyles = getResumeStyles();

      // Call the backend to generate PDF
      const accessToken = localStorage.getItem("objectId");
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/generate-pdf/resume-pdf`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          headTags,
          resumeStyles,
          htmlContent: resumeHTML
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to generate PDF: ${response.statusText}`);
      }

      const pdfBuffer = await response.blob();

      if (pdfBuffer.size < 1024) {
        throw new Error('Generated PDF file is too small and may be corrupted.');
      }

      // Create a file from the blob
      const file = new File(
        [pdfBuffer],
        `${userDetails?.firstName || 'User'} Resume-${Date.now()}.pdf`,
        { type: 'application/pdf' }
      );

      return file;
    } catch (error) {
      console.error('Error generating PDF:', error);
      return null;
    }
  };

  // Helper function to create the HTML for the resume
  // const createResumeHTML = (
  //   profData,
  //   profSkills,
  //   profExperience,
  //   profEducation,
  //   profCertificate,
  //   profProject,
  //   softSkills,
  //   toolsSkills,
  //   userDetail,
  //   personalData,
  //   profImageData
  // ) => {
  //   const tempDiv = document.createElement('div');
  //   tempDiv.className = 'profile-resume';

  //   // Get contact info from personalData or userDetails
  //   const email = personalData?.personal_email || userDetail?.email || '';
  //   const phone = personalData?.phone_no || userDetail?.phone || '';
  //   const name = userDetail?.firstName && userDetail?.lastName 
  //     ? `${userDetail.firstName} ${userDetail.lastName}` 
  //     : userDetail?.name || '';
  //   const designation = profData?.designation || '';
  //   const profilePic = profImageData?.user_profile_url || userDetail?.proFile || '';

  //   // Side content
  //   const sideContent = document.createElement('section');
  //   sideContent.className = 'resume-side-content';

  //   sideContent.innerHTML = `
  //     <div class="resume-header mb-3">
  //       <div class="resume-profile-container mb-2">
  //         <img src="${profilePic}" alt="${name}" class="cover-image" />
  //       </div>
  //       <div class="resume-profile-name">${name}</div>
  //       <div class="resume-profile-headline">${designation}</div>
  //     </div>
  //     <div class="resume-divider" />
  //     <div class="resume-contact-list">
  //       ${email ? `
  //         <a href="mailto:${email}" target="_blank" rel="noreferrer">
  //           <div class="resume-contact-item">
  //             <div class="resume-contact-icon-container">📧</div>
  //             <div>
  //               <div class="resume-contact-label">Email</div>
  //               <div class="resume-contact-id">${email}</div>
  //             </div>
  //           </div>
  //         </a>
  //       ` : ''}
  //       ${phone ? `
  //         <a href="tel:${phone}" target="_blank" rel="noreferrer">
  //           <div class="resume-contact-item">
  //             <div class="resume-contact-icon-container">📞</div>
  //             <div>
  //               <div class="resume-contact-label">Phone</div>
  //               <div class="resume-contact-id">${phone}</div>
  //             </div>
  //           </div>
  //         </a>
  //       ` : ''}
  //     </div>
  //   `;
  //   tempDiv.appendChild(sideContent);

  //   // Main body with sections
  //   const mainBody = document.createElement('section');
  //   mainBody.className = 'resume-main-body';
  //   let sectionsHTML = '';

  //   // 1. Summary
  //   if (profData?.about_me) {
  //     sectionsHTML += `
  //       <section class="resume-main-section">
  //         <div class="resume-section-title">Summary</div>
  //         <div>
  //           <div class="resume-project-desc line-break">${profData.about_me}</div>
  //         </div>
  //       </section>
  //     `;
  //   }

  //   // 2. Projects
  //   if (profProject && profProject.length > 0) {
  //     sectionsHTML += `
  //       <section class="resume-main-section">
  //         <div class="resume-project-section">
  //           <div class="resume-section-title">Projects</div>
  //           <div class="resume-section-body">
  //             ${profProject.map(project => `
  //               <div class="resume-section-item">
  //                 <div class="resume-project-item">
  //                   <div class="resume-project-title">${project?.project_name || ''}</div>
  //                   <div class="resume-project-desc line-break">${project?.project_description || ''}</div>
  //                 </div>
  //               </div>
  //             `).join('')}
  //           </div>
  //         </div>
  //       </section>
  //     `;
  //   }

  //   // 3. Experience
  //   if (profExperience && profExperience.length > 0) {
  //     sectionsHTML += `
  //       <section class="resume-main-section">
  //         <div class="resume-experience-section">
  //           <div class="resume-section-title">Experience</div>
  //           <div class="resume-section-body">
  //             ${profExperience.map(exp => `
  //               <div class="resume-section-item">
  //                 <div class="resume-exp-content-left">
  //                   <div class="exp-time-location">
  //                     <span class="me-1">
  //                       ${exp?.start_month || ''} ${exp?.start_year || ''} -
  //                       ${exp?.is_currently_working ? 'Present' : `${exp?.end_month || ''} ${exp?.end_year || ''}`}
  //                     </span>
  //                     ${exp?.location ? `
  //                       <span class="resume-exp-location">
  //                         📍 <span>${exp?.location} ${exp?.location_type ? '• ' + exp?.location_type : ''}</span>
  //                       </span>
  //                     ` : ''}
  //                   </div>
  //                   <div class="exp-name-logo">
  //                     ${exp?.company_logo ? `
  //                       <div class="resume-exp-logo">
  //                         <img src="${exp.company_logo}" alt="logo" class="contain-image" />
  //                       </div>
  //                     ` : ''}
  //                     <div class="resume-exp-name">
  //                       <div class="resume-exp-designation">${exp?.role_title || ''}</div>
  //                       <div class="resume-exp-company">${exp?.company_name || ''}</div>
  //                     </div>
  //                   </div>
  //                 </div>
  //                 ${exp?.details ? `
  //                   <div class="resume-project-desc line-break ps-3 py-2">
  //                     ${exp.details}
  //                   </div>
  //                 ` : ''}
  //               </div>
  //             `).join('')}
  //           </div>
  //         </div>
  //       </section>
  //     `;
  //   }

  //   // 4. Education
  //   if (profEducation && profEducation.length > 0) {
  //     sectionsHTML += `
  //       <section class="resume-main-section">
  //         <div class="resume-education-section">
  //           <div class="resume-section-title">Education</div>
  //           <div class="resume-section-body">
  //             ${profEducation.map(edu => `
  //               <div class="resume-section-item">
  //                 <div class="edu-name-logo">
  //                   ${edu?.logo_link ? `<img src="${edu.logo_link}" alt="Institute Logo" />` : ''}
  //                   <div>${edu?.institute_name || ''}</div>
  //                 </div>
  //                 <div class="edu-degree-time">
  //                   <div class="resume-edu-degree">
  //                     ${edu?.degree || edu?.educational_level || ''}
  //                   </div>
  //                   <div class="resume-edu-time">
  //                     ${edu?.start_year || ''} - ${edu?.is_pursuing ? 'Present' : edu?.end_year || ''}
  //                   </div>
  //                 </div>
  //               </div>
  //             `).join('')}
  //           </div>
  //         </div>
  //       </section>
  //     `;
  //   }

  //   // 5. Certificates
  //   if (profCertificate && profCertificate.length > 0) {
  //     sectionsHTML += `
  //       <section class="resume-main-section">
  //         <div class="resume-education-section">
  //           <div class="resume-section-title">Certificates</div>
  //           <div class="resume-section-body">
  //             ${profCertificate.map(cert => `
  //               <div class="resume-section-item">
  //                 <div class="edu-name-logo">
  //                   ${cert?.certificate_logo ? `<img src="${cert.certificate_logo}" alt="Certificate Logo" />` : ''}
  //                   <div>${cert?.course_name || ''}</div>
  //                 </div>
  //                 <div class="edu-degree-time">
  //                   <div class="resume-edu-degree">
  //                     ${cert?.organisation_name || ''}
  //                   </div>
  //                   <div class="resume-edu-time">
  //                     ${cert?.issue_date || ''} ${cert?.year || ''}
  //                   </div>
  //                 </div>
  //               </div>
  //             `).join('')}
  //           </div>
  //         </div>
  //       </section>
  //     `;
  //   }

  //   // 6. Skills
  //   if (softSkills && softSkills.length > 0) {
  //     sectionsHTML += `
  //       <section class="resume-main-section">
  //         <div class="resume-skills-section">
  //           <div class="resume-section-title">Soft Skills</div>
  //           <div class="resume-section-body">
  //             <div class="d-flex flex-column gap-2">
  //               <div class="resume-skills-row">
  //                 ${softSkills.map(skill => `
  //                   <div class="resume-section-item word-break">${skill}</div>
  //                 `).join('')}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </section>
  //     `;
  //   }

  //   if (profSkills && profSkills.length > 0) {
  //     sectionsHTML += `
  //       <section class="resume-main-section">
  //         <div class="resume-skills-section">
  //           <div class="resume-section-title">Professional Skills</div>
  //           <div class="resume-section-body">
  //             <div class="d-flex flex-column gap-2">
  //               <div class="resume-skills-row">
  //                 ${profSkills.map(skill => `
  //                   <div class="resume-section-item word-break">${skill}</div>
  //                 `).join('')}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </section>
  //     `;
  //   }

  //   if (toolsSkills && toolsSkills.length > 0) {
  //     sectionsHTML += `
  //       <section class="resume-main-section">
  //         <div class="resume-tools-section">
  //           <div class="resume-section-title">Tools</div>
  //           <div class="resume-section-body">
  //             <div class="resume-skills-row resume-tools-row">
  //               ${toolsSkills.map(tool => `
  //                 <div class="resume-section-item word-break">${tool}</div>
  //               `).join('')}
  //             </div>
  //           </div>
  //         </div>
  //       </section>
  //     `;
  //   }

  //   mainBody.innerHTML = sectionsHTML;
  //   tempDiv.appendChild(mainBody);

  //   return tempDiv.outerHTML;
  // };

  const createResumeHTML = (
    profData,
    profSkills,
    profExperience,
    profEducation,
    profCertificate,
    profProject,
    softSkills,
    toolsSkills,
    userDetail,
    personalData,
    profImageData
  ) => {
    // Debug logging
    // console.log("🔍 createResumeHTML - Data received:");
    // console.log("📚 Education:", profEducation);
    // console.log("💼 Experience:", profExperience);

    const tempDiv = document.createElement('div');
    tempDiv.className = 'profile-resume';

    // Get contact info
    const email = personalData?.personal_email || userDetail?.email || '';
    const phone = personalData?.phone_no || userDetail?.phone || '';
    const name = userDetail?.firstName && userDetail?.lastName
      ? `${userDetail.firstName} ${userDetail.lastName}`
      : userDetail?.name || '';
    const designation = profData?.designation || '';
    const profilePic = profImageData?.user_profile_url || userDetail?.proFile || '';

    // Side content
    const sideContent = document.createElement('section');
    sideContent.className = 'resume-side-content';

    sideContent.innerHTML = `
    <div class="resume-header mb-3">
      <div class="resume-profile-container mb-2">
        <img src="${profilePic}" alt="${name}" class="cover-image" />
      </div>
      <div class="resume-profile-name">${name}</div>
      <div class="resume-profile-headline">${designation}</div>
    </div>
    <div class="resume-divider" />
    <div class="resume-contact-list">
      ${email ? `
        <a href="mailto:${email}" target="_blank" rel="noreferrer">
          <div class="resume-contact-item">
            <div class="resume-contact-icon-container">📧</div>
            <div>
              <div class="resume-contact-label">Email</div>
              <div class="resume-contact-id">${email}</div>
            </div>
          </div>
        </a>
      ` : ''}
      ${phone ? `
        <a href="tel:${phone}" target="_blank" rel="noreferrer">
          <div class="resume-contact-item">
            <div class="resume-contact-icon-container">📞</div>
            <div>
              <div class="resume-contact-label">Phone</div>
              <div class="resume-contact-id">${phone}</div>
            </div>
          </div>
        </a>
      ` : ''}
    </div>
  `;
    tempDiv.appendChild(sideContent);

    // Main body with sections
    const mainBody = document.createElement('section');
    mainBody.className = 'resume-main-body';
    let sectionsHTML = '';

    // 1. Summary
    if (profData?.about_me) {
      sectionsHTML += `
      <section class="resume-main-section">
        <div class="resume-section-title">Summary</div>
        <div>
          <div class="resume-project-desc line-break">${profData.about_me}</div>
        </div>
      </section>
    `;
    }

    // 2. Projects
    if (profProject && profProject.length > 0) {
      sectionsHTML += `
      <section class="resume-main-section">
        <div class="resume-project-section">
          <div class="resume-section-title">Projects</div>
          <div class="resume-section-body">
            ${profProject.map(project => `
              <div class="resume-section-item">
                <div class="resume-project-item">
                  <div class="resume-project-title">${project?.project_name || ''}</div>
                  <div class="resume-project-desc line-break">${project?.project_description || ''}</div>
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      </section>
    `;
    }

    // 3. Experience - FIXED for the actual data structure
    if (profExperience && profExperience.length > 0) {
      // console.log("✅ Building Experience section with:", profExperience.length, "items");

      sectionsHTML += `
      <section class="resume-main-section">
        <div class="resume-experience-section">
          <div class="resume-section-title">Experience</div>
          <div class="resume-section-body">
            ${profExperience.map(exp => {
        // Handle start month - could be string like "Mar" or null
        const startMonth = exp?.start_month || '';
        const endMonth = exp?.end_month || '';
        const startYear = exp?.start_year || '';
        const endYear = exp?.end_year || '';
        const isCurrentlyWorking = exp?.is_currently_working || false;

        // Format date display
        let dateDisplay = '';
        if (startMonth && startYear) {
          dateDisplay = `${startMonth} ${startYear}`;
        } else if (startYear) {
          dateDisplay = startYear;
        } else {
          dateDisplay = 'Date not specified';
        }

        if (isCurrentlyWorking) {
          dateDisplay += ' - Present';
        } else if (endMonth && endYear) {
          dateDisplay += ` - ${endMonth} ${endYear}`;
        } else if (endYear) {
          dateDisplay += ` - ${endYear}`;
        }

        // console.log(`📝 Experience: ${exp?.company_name || 'Unknown'} - ${exp?.role_title || 'No Role'} - ${dateDisplay}`);

        return `
                <div class="resume-section-item">
                  <div class="resume-exp-content-left">
                    <div class="exp-time-location">
                      <span class="me-1">${dateDisplay}</span>
                      ${exp?.location ? `
                        <span class="resume-exp-location">
                          📍 <span>${exp.location} ${exp?.location_type ? '• ' + exp.location_type : ''}</span>
                        </span>
                      ` : ''}
                    </div>
                    <div class="exp-name-logo">
                      ${exp?.company_logo ? `
                        <div class="resume-exp-logo">
                          <img src="${exp.company_logo}" alt="logo" class="contain-image" />
                        </div>
                      ` : ''}
                      <div class="resume-exp-name">
                        <div class="resume-exp-designation">${exp?.role_title || ''}</div>
                        <div class="resume-exp-company">${exp?.company_name || ''}</div>
                      </div>
                    </div>
                  </div>
                  ${exp?.details ? `
                    <div class="resume-project-desc line-break ps-3 py-2">
                      ${exp.details}
                    </div>
                  ` : ''}
                  ${exp?.responsibility ? `
                    <div class="resume-project-desc line-break ps-3 py-2">
                      ${exp.responsibility}
                    </div>
                  ` : ''}
                </div>
              `;
      }).join('')}
          </div>
        </div>
      </section>
    `;
    } else {
      console.log("⚠️ No Experience data found");
    }

    // 4. Education - FIXED for the actual data structure
    if (profEducation && profEducation.length > 0) {
      // console.log("✅ Building Education section with:", profEducation.length, "items");

      sectionsHTML += `
      <section class="resume-main-section">
        <div class="resume-education-section">
          <div class="resume-section-title">Education</div>
          <div class="resume-section-body">
            ${profEducation.map(edu => {
        const instituteName = edu?.institute_name || '';
        const degree = edu?.degree || '';
        const educationalLevel = edu?.educational_level || '';
        const isPursuing = edu?.is_pursuing || false;
        const startYear = edu?.start_year || '';
        const endYear = edu?.end_year || '';

        // Determine the degree display
        let degreeDisplay = degree;
        if (!degreeDisplay && educationalLevel) {
          degreeDisplay = educationalLevel;
        }

        // Format date
        let dateDisplay = '';
        if (startYear) {
          dateDisplay = startYear;
        }
        if (isPursuing) {
          dateDisplay += dateDisplay ? ' - Present' : 'Present';
        } else if (endYear) {
          dateDisplay += dateDisplay ? ` - ${endYear}` : endYear;
        }

        // console.log(`🎓 Education: ${instituteName} - ${degreeDisplay} - ${dateDisplay || 'Date not specified'}`);

        return `
                <div class="resume-section-item">
                  <div class="edu-name-logo">
                    ${edu?.logo_link ? `<img src="${edu.logo_link}" alt="Institute Logo" />` : ''}
                    <div>${instituteName}</div>
                  </div>
                  <div class="edu-degree-time">
                    <div class="resume-edu-degree">
                      ${degreeDisplay || 'Education'}
                    </div>
                    ${dateDisplay ? `
                      <div class="resume-edu-time">
                        ${dateDisplay}
                      </div>
                    ` : ''}
                  </div>
                </div>
              `;
      }).join('')}
          </div>
        </div>
      </section>
    `;
    } else {
      console.log("⚠️ No Education data found");
    }

    // 5. Certificates
    if (profCertificate && profCertificate.length > 0) {
      sectionsHTML += `
      <section class="resume-main-section">
        <div class="resume-education-section">
          <div class="resume-section-title">Certificates</div>
          <div class="resume-section-body">
            ${profCertificate.map(cert => `
              <div class="resume-section-item">
                <div class="edu-name-logo">
                  ${cert?.certificate_logo ? `<img src="${cert.certificate_logo}" alt="Certificate Logo" />` : ''}
                  <div>${cert?.course_name || ''}</div>
                </div>
                <div class="edu-degree-time">
                  <div class="resume-edu-degree">
                    ${cert?.organisation_name || ''}
                  </div>
                  <div class="resume-edu-time">
                    ${cert?.issue_date || ''} ${cert?.year || ''}
                  </div>
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      </section>
    `;
    }

    // 6. Skills - Soft Skills
    if (softSkills && softSkills.length > 0) {
      sectionsHTML += `
      <section class="resume-main-section">
        <div class="resume-skills-section">
          <div class="resume-section-title">Soft Skills</div>
          <div class="resume-section-body">
            <div class="d-flex flex-column gap-2">
              <div class="resume-skills-row">
                ${softSkills.map(skill => `
                  <div class="resume-section-item word-break">${skill}</div>
                `).join('')}
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
    }

    // 7. Skills - Professional Skills
    if (profSkills && profSkills.length > 0) {
      sectionsHTML += `
      <section class="resume-main-section">
        <div class="resume-skills-section">
          <div class="resume-section-title">Professional Skills</div>
          <div class="resume-section-body">
            <div class="d-flex flex-column gap-2">
              <div class="resume-skills-row">
                ${profSkills.map(skill => `
                  <div class="resume-section-item word-break">${skill}</div>
                `).join('')}
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
    }

    // 8. Skills - Tools
    if (toolsSkills && toolsSkills.length > 0) {
      sectionsHTML += `
      <section class="resume-main-section">
        <div class="resume-tools-section">
          <div class="resume-section-title">Tools</div>
          <div class="resume-section-body">
            <div class="resume-skills-row resume-tools-row">
              ${toolsSkills.map(tool => `
                <div class="resume-section-item word-break">${tool}</div>
              `).join('')}
            </div>
          </div>
        </div>
      </section>
    `;
    }

    mainBody.innerHTML = sectionsHTML;
    tempDiv.appendChild(mainBody);

    return tempDiv.outerHTML;
  };

  // Get resume styles
  const getResumeStyles = () => {
    return `
      .profile-resume {color: rgb(0, 0, 0, 0.87); font-family: 'Lato', sans-serif; font-size: 11pt; display: flex; flex-direction: row; }
      .profile-resume .resume-side-content { flex: 0 0 30%; background-color: #F7F9FC; padding: 20px; height: 100vh; min-height: 100vh; }
      .profile-resume .resume-main-body { flex: 0 0 70%; background-color: #ffffff; padding: 24px 16px 24px 16px; position: relative; }
      .resume-main-section { padding-bottom: 20px; padding-left: 20px; }
      .resume-side-content .resume-header .resume-profile-container { height: 4rem; width: 4rem; border-radius: 50%; overflow: hidden; }
      .resume-profile-name { font-size: 12pt; font-weight: 700; }
      .resume-profile-headline { font-weight: 700; color: rgba(0, 0, 0, 0.60); }
      .resume-side-content .resume-divider { background-color: #EDF0F5; height: 1px; width: 100%; margin: 1rem 0; }
      .resume-side-content .resume-contact-list { display: flex; flex-direction: column; gap: 0.5rem; }
      .resume-contact-list a { text-decoration: none; color: unset; }
      .resume-contact-item { display: flex; align-items: center; gap: 0.5rem; }
      .resume-contact-icon-container { border-radius: 50%; height: 24px; width: 24px; background-color: #E2E6EE; display: flex; justify-content: center; align-items: center; }
      .resume-contact-id { font-size: 11pt; color: rgb(0, 0, 0, 0.87); }
      .resume-section-title::before { content: '•'; height: 1.5rem; width: 1.5rem; background-color: white; position: absolute; left: -30px; top: -4px;
        border-radius: 50%; display: flex; align-items: center; justify-content: center;
        color: purple; font-size: 14pt; }
      .resume-main-section .resume-section-title { font-size: 12.5pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 1rem; position: relative; }
      .resume-project-section .resume-section-body { display: grid; grid-template-columns: repeat(2, 1fr); gap: 4px; }
      .resume-project-section .resume-section-item { display: flex; flex-direction: column; gap: 8px; padding: 10px; background-color: #F7F9FC; border-radius: 4px; overflow: hidden; }
      .resume-project-title { font-size: 11pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 4px; }
      .resume-project-desc { font-size: 10pt; color: rgba(0, 0, 0, 0.60); line-break: pre-line; white-space: pre-line; }
      .resume-experience-section .resume-section-body { padding-left: 20px; display: flex; flex-direction: column; }
      .resume-experience-section .resume-section-item { display: flex; flex-direction: column; gap: 6px; padding: 4px 0 8px; overflow: hidden; color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
      .resume-experience-section .resume-section-item:not(:last-child) { border-bottom: 0.7px solid lightgray; }
      .resume-exp-content-left .exp-time-location { margin-bottom: 0.25rem; padding-left: 12px; position: relative; }
      .resume-exp-content-left .exp-time-location::before { content: ''; height: 4px; width: 4px; background-color: black; position: absolute; left: 0; top: 4px; border-radius: 50%; }
      .resume-exp-content-left .exp-name-logo { display: flex; gap: 8px; align-items: center; padding-left: 12px; border-left: 1px solid #F7F9FC; margin-left: 1px; }
      .exp-name-logo .resume-exp-logo { height: 34px; width: 34px; overflow: hidden; }
      .resume-exp-logo img { height: 100%; width: 100%; object-fit: contain; }
      .resume-exp-name .resume-exp-designation { color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
      .resume-exp-name .resume-exp-company { color: rgb(0, 0, 0, 0.87); font-size: 11pt; }
      .resume-exp-location { display: inline-flex; align-items: center; }
      .resume-education-section .resume-section-body { display: flex; flex-wrap: wrap; gap: 4px; }
      .resume-education-section .resume-section-item { flex: 0 0 30%; border-radius: 4px; padding: 6px 12px; background-color: #F7F9FC; display: flex; flex-direction: column; gap: 4px; font-size: 10pt; max-width: 32%; }
      .resume-section-item .edu-name-logo { display: flex; align-items: center; gap: 4px; }
      .resume-section-item .edu-name-logo img { height: 28px; width: 28px; object-fit: contain; overflow: hidden; }
      .resume-section-item .edu-degree-time .resume-edu-degree { font-size: 10pt; font-weight: 700; margin-bottom: 1px; }
      .resume-section-item .edu-degree-time .resume-edu-time { color: rgba(0, 0, 0, 0.60); }
      .resume-skills-section .resume-section-body { display: flex; flex-direction: column; gap: 8px; }
      .resume-skills-row { display: flex; gap: 8px; flex-wrap: wrap; flex: 0 0 68%; }
      .resume-skills-row .resume-section-item { border-radius: 4px; padding: 6px 4px; background-color: #F7F9FC; max-width: 70%; overflow: hidden; display: flex; align-items: center; }
      .resume-tools-section .resume-section-body { display: flex; }
      .resume-section-body .resume-skills-row.resume-tools-row { flex: 0 0 90%; max-width: 90%; }
      .contain-image { height: 100%; width: 100%; object-fit: contain; }
      .cover-image { height: 100%; width: 100%; object-fit: cover; }
      .d-flex { display: flex !important; }
      .flex-column { flex-direction: column !important; }
      .gap-2 { gap: 0.5rem; }
      .word-break { word-break: break-word; }
      .line-break { white-space: pre-line; }
      .ps-3 {padding-left: 1rem}
      .py-2 {padding-top: .5rem !important;padding-bottom: .5rem !important;}
      .me-1 { margin-right: 0.25rem; }
      .mb-1 { margin-bottom: 0.25rem; }
      .mb-2 { margin-bottom: 0.5rem; }
      @page { size: A4; margin: 2mm 2mm 2mm 2mm; }
      * { box-sizing: border-box; }
    `;
  };

  // Function to save the generated PDF to the database
  const savePdfToDatabase = async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('section_slug', 'resume_details');

      const response = await dispatch(postResumeReducer(formData));

      if (response?.payload?.statusCode === 200) {
        await dispatch(getResumeReducer());
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error saving PDF:', error);
      return false;
    }
  };

  // Main handler - parse resume and then generate AI resume automatically
  const handleParseAndGenerateResume = async () => {
    if (!resumeFile) {
      openSnackbar("Upload a resume first, or use Skip to continue.", "info");
      return;
    }

    setIsParsing(true);
    handleInfo("Uploading your resume...");

    try {
      // 1. Parse the resume
      const res = await dispatch(postResumePraising({ resume: resumeFile }));
      // console.log("ResponseResume", res);

      if (res?.type === postResumePraising.fulfilled.type) {
        openSnackbar("Resume parsed successfully!", "success");

        // 2. Fetch all updated data after parsing
        handleInfo("Fetching updated profile data...");

        await dispatch(getProfessionalInfoReducer());
        await dispatch(getPersonalProfileDataReducer());
        await dispatch(getExperienceReducer());
        await dispatch(getEducationReducer());
        await dispatch(getCertificateReducer());
        await dispatch(getProjecteReducer());
        await dispatch(getProfessionalSkillsReducer());
        await dispatch(getKycOcrApiReducer());
        await dispatch(getKycPanOcrApiReducer());

        // 3. Wait for data to be available in Redux
        await new Promise(resolve => setTimeout(resolve, 2000));

        // 4. Generate the AI resume
        setIsGenerating(true);
        handleInfo("Generating your AI resume...");

        const pdfFile = await generateResumePDF();

        if (pdfFile) {
          const saved = await savePdfToDatabase(pdfFile);
          if (saved) {
            openSnackbar("AI Resume generated successfully!", "success");
          } else {
            openSnackbar("Failed to save generated resume", "error");
          }
        } else {
          openSnackbar("Failed to generate AI resume", "error");
        }

        setIsGenerating(false);

        // 5. Navigation logic
        const isOnboarding = backLinkUrl?.includes('/onboarding');
        const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
        const hasOnboardingPath = isOnboarding || isUniversityOnboarding;

        if (hasOnboardingPath) {
          navigate("/verify-docs", {
            state: { docType: 'Aadhaar' },
            replace: true
          });
        } else if (checkType) {
          let organizationId, id, userType;
          const params = new URLSearchParams(deeLinkURLPath.split('?')[1]);
          organizationId = params.get('organizationId');
          id = params.get('id');
          userType = params.get('type');
          const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
          window.location.replace(`${baseUrl}/?userType=${userType}`);
          dispatch(setDeeplinking(""));
        } else if (CheckJob) {
          const result = await dispatch(applyJob(jobId));
          dispatch(setDeeplinking(""));
          if (result?.payload?.statusCode === 200 || result?.payload?.statusCode === 201) {
            openSnackbar("Applied successfully! Add your video resume to get shortlisted quickly.", "success");
            navigate("/home");
            window.location.reload();
          }
        } else {
          navigate("/home");
          window.location.reload();
        }
      } else {
        console.log('errrror', res);
        openSnackbar("Failed to parse resume", "error");
      }

    } catch (error) {
      console.error("Resume upload failed:", error);
      openSnackbar("Unable to upload the resume right now. Please try again.", "error");
    } finally {
      setIsParsing(false);
      setIsGenerating(false);
    }
  };

  const selectedFileLabel = resumeFile
    ? `${resumeFile.name} - ${(resumeFile.size / (1024 * 1024)).toFixed(1)} MB`
    : "PDF, DOC, or DOCX up to 10MB";

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 180px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 2, sm: 3 },
        py: { xs: 2, md: 4 },
        backgroundColor: "#ffffff",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 720,
          borderRadius: 5,
          overflow: "hidden",
          backgroundColor: "#ffffff",
          color: "#111827",
          border: "1px solid rgba(0, 68, 198, 0.12)",
          boxShadow: "0 20px 55px rgba(0, 68, 198, 0.12)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: { xs: 2, sm: 3 },
            pt: { xs: 2, sm: 2.5 },
          }}
        >
          <IconButton
            onClick={handleBack}
            aria-label="Go back"
            sx={{
              color: "#0044C6",
              bgcolor: "rgba(0, 68, 198, 0.06)",
              "&:hover": { bgcolor: "rgba(0, 68, 198, 0.12)" },
            }}
          >
            <ArrowBackRoundedIcon />
          </IconButton>

          <Button
            onClick={handleSkip}
            disabled={!hasUserData}
            sx={{
              color: "#0044C6",
              fontWeight: 700,
              fontSize: "0.98rem",
              textTransform: "none",
              minWidth: 0,
              p: 0,
              "&:hover": {
                backgroundColor: "transparent",
                opacity: 0.9,
              },
              "&.Mui-disabled": { 
                opacity: 0.5,
                cursor: "not-allowed",
              },
            }}
          >
            Skip
          </Button>
        </Box>

        <Box
          sx={{
            px: { xs: 2, sm: 4, md: 6 },
            pt: { xs: 2, sm: 3 },
            pb: { xs: 2, sm: 4 },
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: 92,
              height: 92,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              mx: "auto",
              mb: 2.5,
              background: "rgba(0, 68, 198, 0.08)",
              boxShadow: "inset 0 0 0 1px rgba(0, 68, 198, 0.12)",
            }}
          >
            <CloudUploadOutlinedIcon sx={{ fontSize: 42, color: "#0044C6" }} />
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "1.55rem", sm: "2rem" },
              fontWeight: 800,
              lineHeight: 1.15,
              mb: 1.5,
              color: "#0f172a",
            }}
          >
            Autofill Your Profile
          </Typography>

          <Typography
            sx={{
              color: "#475569",
              maxWidth: 560,
              mx: "auto",
              fontSize: { xs: "0.98rem", sm: "1.05rem" },
              lineHeight: 1.65,
            }}
          >
            Upload your resume to automatically fill your profile, experience,
            education, and skills in seconds.
          </Typography>

          <Box
            onClick={() => fileInputRef.current?.click()}
            onDragOver={(event) => {
              event.preventDefault();
              setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={handleDrop}
            sx={{
              mt: { xs: 3, sm: 4 },
              border: "1.8px dashed rgba(0, 68, 198, 0.35)",
              borderRadius: 3,
              minHeight: { xs: 170, sm: 190 },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              px: 3,
              py: 3,
              cursor: "pointer",
              backgroundColor: isDragging ? "rgba(0, 68, 198, 0.05)" : "#f8fbff",
              transition: "all 180ms ease",
              "&:hover": {
                borderColor: "#0044C6",
                backgroundColor: "#f1f7ff",
              },
            }}
          >
            <Box
              sx={{
                width: 58,
                height: 58,
                borderRadius: "50%",
                display: "grid",
                placeItems: "center",
                mb: 1.5,
                backgroundColor: "rgba(0, 68, 198, 0.06)",
              }}
            >
              <DescriptionOutlinedIcon sx={{ color: "#0044C6", fontSize: 30 }} />
            </Box>

            <Typography
              sx={{
                color: "#0044C6",
                fontWeight: 800,
                fontSize: "1.05rem",
                lineHeight: 1.2,
              }}
            >
              {resumeFile ? "Resume selected" : "Upload Resume"}
            </Typography>

            <Typography
              sx={{
                color: "#64748b",
                fontSize: "0.92rem",
                mt: 0.5,
                textAlign: "center",
              }}
            >
              {selectedFileLabel}
            </Typography>

            {resumeFile && (
              <Box
                sx={{
                  mt: 1.5,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.8,
                  color: "#0044C6",
                  fontSize: "0.9rem",
                  fontWeight: 600,
                }}
              >
                <CheckCircleRoundedIcon sx={{ fontSize: 18 }} />
                Ready to upload
              </Box>
            )}

            <input
              ref={fileInputRef}
              type="file"
              hidden
              accept=".pdf,.doc,.docx,.rtf"
              onChange={handleFileChange}
            />
          </Box>

          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                color: "#64748b",
                fontSize: "0.9rem",
              }}
            >
              10MB max file size
            </Typography>
          </Box>

          <Box
            sx={{
              mt: { xs: 4, sm: 5 },
              display: "grid",
              gap: 1.25,
            }}
          >
            <Button
              variant="contained"
              onClick={handleParseAndGenerateResume}
              disabled={isParsing || isGenerating}
              sx={{
                py: 1.35,
                borderRadius: 2,
                background: "#0044C6",
                color: "#ffffff",
                fontWeight: 800,
                textTransform: "none",
                fontSize: "1rem",
                boxShadow: "none",
                "&:hover": {
                  background: "#003aa9",
                  boxShadow: "none",
                },
                "&.Mui-disabled": {
                  color: "#ffffff",
                  opacity: 0.72,
                },
              }}
            >
              {isParsing ? "Uploading Resume..." : isGenerating ? "Generating AI Resume..." : "Parse & Generate Resume"}
            </Button>

            <Button
              variant="text"
              onClick={handleSkip}
              disabled={!hasUserData}
              sx={{
                color: "#0044C6",
                textTransform: "none",
                fontWeight: 700,
                opacity: 0.82,
                "&:hover": {
                  backgroundColor: "transparent",
                  opacity: 1,
                },
                "&.Mui-disabled": {  
                  opacity: 0.4,
                  cursor: "not-allowed",
                },
              }}
            >
              Skip for now
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default ActiveStep8;